/**
 * Deutsche Texte — die Ausgangssprache der App.
 *
 * Kein Text steht im Markup. Das ist keine Vorsorge für eine Übersetzung, die nie
 * kommt: Texte an einem Ort lassen sich überhaupt erst überarbeiten, und beim
 * Nachrüsten fasst man jede Datei zweimal an.
 */
export const de = {
  app: {
    name: 'Kraftwerk',
    tagline: 'Training, Ernährung und Supplements — an einem Ort.',
  },
  update: {
    available: 'Eine neue Version ist bereit.',
    required:
      'Diese Version ist veraltet. Bis zum Aktualisieren bleiben deine Änderungen auf dem Gerät.',
    apply: 'Jetzt aktualisieren',
  },
  nav: {
    plan: 'Planen',
    today: 'Heute',
    training: 'Training',
    nutrition: 'Ernährung',
    journal: 'Tagebuch',
    household: 'Haushalt',
    shopping: 'Einkauf',
    costs: 'Kosten',
    pocket: 'Taschengeld',
    members: 'Mitglieder',
    meals: 'Essen',
    family: 'Familie',
    community: 'Community',
  },
  rooms: {
    label: 'Räume',
    switch: 'Raum wechseln – jetzt {{room}}',
    sheetTitle: 'Raum wählen',
    sheetHint: 'Abkürzung: auf dem Raum-Knopf nach oben wischen.',
    close: 'Schließen',
    current: 'Hier bist du',
    me: 'Ich',
    household: 'Haushalt',
    family: 'Familie',
    community: 'Community',
    meHint: 'Dein Tag: Training, Ernährung, Tagebuch, eigene Planung.',
    householdHint: 'Wer hier wohnt: Einkauf, Kosten, gemeinsame Planung, Mitglieder.',
    familyHint: 'Wer mithilft, ohne hier zu wohnen — kommt.',
    communityHint: 'Umgebung bis deutschlandweit — kommt.',
  },
  householdToday: {
    heading: 'Heute im Haushalt',
    membersHint: 'Einladen, Kinder, Stufen, Standort und Familienanzeige',
    noHousehold: 'Noch kein Haushalt auf diesem Gerät — er kommt mit dem ersten Abgleich.',
    events: 'Termine heute',
    noEvents: 'Heute keine Haushaltstermine.',
    allDay: 'ganztägig',
    forWhom: 'für {{names}}',
    tasks: 'Geteilte Aufgaben heute',
    noTasks: 'Heute ist keine geteilte Aufgabe fällig.',
    everyone: 'Für alle',
    taskCount_one: '{{count}} Aufgabe',
    taskCount_other: '{{count}} Aufgaben',
    toPlan: 'Zur Planung',
    shopping: 'Einkaufsliste',
    shoppingOpen_one: '{{count}} Eintrag offen',
    shoppingOpen_other: '{{count}} Einträge offen',
    shoppingEmpty: 'Nichts auf der Liste.',
    toList: 'Zur Liste',
    stars: 'Sterne',
    starsOf: '{{name}}: {{count}}',
    familyDisplay: 'Familienanzeige öffnen',
  },
  familyRoom: {
    heading: 'Familie',
    intro:
      'Hier kommen die dazu, die nicht bei euch wohnen, aber mithelfen — Oma und Opa, die aufpassen, zu Terminen begleiten oder mal kochen.',
    comingHeading: 'Kommt',
    comingInvite:
      'Einladen mit eingeschränkter Sicht: Sie sehen nur, was ihr freigebt — nie Tagebuch, Körperwerte oder Kosten.',
    comingEvents: 'Gemeinsame Termine: wer wann aufpasst, wer wohin begleitet.',
    comingTasks: 'Aufgaben wie „Mittwoch kochen“ an jemanden außerhalb des Haushalts geben.',
    notYet: 'Noch gibt es hier keine Funktion — einladen kann man niemanden.',
    meanwhileHeading: 'Bis dahin',
    meanwhile:
      'Termine des Haushalts haben schon „für wen“: wer abgeholt oder begleitet wird. Oma und Opa selbst lassen sich dort noch nicht eintragen.',
    toHouseholdPlan: 'Zur Planung im Haushalt',
  },
  communityRoom: {
    heading: 'Community',
    intro: 'Kraftwerk über den eigenen Haushalt hinaus — von der Umgebung bis deutschlandweit.',
    comingHeading: 'Kommt — als Erstes',
    comingRecipes:
      'Rezepte teilen: eigene Gerichte zeigen und Gerichte anderer in die eigene Sammlung übernehmen.',
    openNote:
      'Was öffentlich geteilt wird, ist bewusst für alle lesbar — anders als deine übrigen Daten, die verschlüsselt sind. Dafür braucht es vorher Moderation und einen Meldeweg.',
    notYet: 'Noch ist hier nichts gebaut, und nichts verlässt dein Konto.',
  },
  login: {
    childOpen: 'Für Kinder: mit Code vom Elterngerät anmelden',
    childCode: 'Code vom Elterngerät',
    childHint:
      'Ein Erwachsener aus deinem Haushalt erzeugt ihn unter Haushalt → Mitglieder. Er gilt 15 Minuten.',
    childSubmit: 'Anmelden',
    childFailed: 'Der Code stimmt nicht oder ist abgelaufen. Bitte einen neuen erzeugen lassen.',
    intro: 'Melde dich an, um weiterzumachen.',
    email: 'E-Mail',
    password: 'Passwort',
    submit: 'Anmelden',
    submitting: 'Melde an …',
    failed: 'E-Mail oder Passwort stimmt nicht.',
    offline: 'Keine Verbindung zum Server. Prüfe das Netz und versuch es noch einmal.',
    tooMany: 'Zu viele Versuche. Bitte in ein paar Minuten erneut.',
    serverError: 'Der Server antwortet gerade nicht.',
    expired_one:
      'Deine Sitzung ist abgelaufen. 1 Änderung wartet auf diesem Gerät und geht nach dem Anmelden raus.',
    expired_other:
      'Deine Sitzung ist abgelaufen. {{count}} Änderungen warten auf diesem Gerät und gehen nach dem Anmelden raus.',
    passkey: 'Mit Passkey anmelden',
    passkeyBusy: 'Warte auf die Bestätigung am Gerät …',
    passkeyFailed:
      'Dieser Passkey ist hier nicht (mehr) eingetragen. Mit Passwort anmelden und ihn in den Einstellungen neu einrichten.',
    closedRegistration:
      'Konten werden auf dem Server angelegt — es gibt bewusst keine Registrierung.',
  },
  session: {
    loading: 'Einen Moment …',
    signedInChild:
      'Angemeldet als Kind dieses Haushalts. Abmelden und neu anmelden geht mit einem neuen Code vom Elterngerät.',
    signedInAs: 'Angemeldet als {{email}}',
    logout: 'Abmelden',
  },
  account: {
    heading: 'Konto',
  },
  gestures: {
    pullHint: 'Ziehen zum Abgleichen',
    pullRelease: 'Loslassen zum Abgleichen',
    undo: 'Rückgängig',
    check: 'Abhaken',
    uncheck: 'Wieder offen',
    done: 'Erledigt',
    delete: 'Löschen',
    deleted: '„{{name}}“ gelöscht',
  },
  shortcuts: {
    heading: 'Kurzbefehle',
    intro:
      'Gewicht und Schritte eintragen (auch von selbst aus Apple Health) und Supplements abhaken, ohne die App zu öffnen — mit der Kurzbefehle-App von iOS („Hey Siri, Gewicht“). Jeder Kurzbefehl bekommt einen eigenen Schlüssel, der nur diese drei Dinge kann und nichts lesen darf.',
    add: 'Kurzbefehl einrichten',
    name: 'Name (zum Wiedererkennen)',
    create: 'Schlüssel erzeugen',
    onlyOnce:
      'Dein Schlüssel — er wird nur jetzt angezeigt. Kopieren und in den Kurzbefehl einsetzen:',
    copy: 'Schlüssel kopieren',
    copied: 'Kopiert',
    done: 'Fertig',
    lastUsed: 'Zuletzt benutzt am {{date}}',
    neverUsed: 'Noch nie benutzt',
    revoke: 'Widerrufen',
    revokeNamed: 'Schlüssel „{{name}}“ widerrufen',
    step1:
      'Kurzbefehle-App → neuer Kurzbefehl „Gewicht“ → Aktion „Nach Eingabe fragen“ (Zahl, „Gewicht in kg?“).',
    step2: 'Aktion „Inhalte von URL abrufen“: {{url}} — Methode POST.',
    step3:
      'Unter „Header“ eine Zeile: links (Schlüssel) Authorization, rechts (Wert) Bearer, ein Leerzeichen und dahinter dein Schlüssel. „Haupttext anfordern“ auf JSON, neues Feld vom Typ Zahl: kg = die Eingabe.',
    step4:
      'Aktion „Wörterbuchwert abrufen“ (message) und „Ergebnis anzeigen“ — dann sagt Siri, was eingetragen wurde.',
    step5: 'Für „Genommen“ einen zweiten Kurzbefehl, gleich gebaut, ohne Eingabe, mit {{url}}.',
    healthHeading: 'Apple Health: Schritte jeden Abend von selbst',
    health1: 'Kurzbefehle-App → Automation → „Tageszeit“, etwa 22:00, „Sofort ausführen“.',
    health2:
      'Aktion „Health-Messungen suchen“: Typ Steps, Startdatum ist heute — dann „Statistik berechnen“: Summe von Health-Messungen.',
    health3:
      'Aktion „Inhalte von URL abrufen“: {{url}}, POST, derselbe Header (Authorization = Bearer und Schlüssel). „Haupttext anfordern“ JSON, neues Feld vom Typ Zahl: steps = Statistiken.',
    health4:
      'Gewicht aus Health: „Health-Messungen suchen“ (Gewicht, neuester Wert) an {{url}} mit kg = der Wert und date = sein Datum (ISO 8601) — dann landet die Waage von gestern auch unter gestern.',
    healthNote:
      'Ein Tag darf bis zu sieben Tage zurückliegen. Schritte stehen im Tagebuch; in die Energiebilanz zählen sie nicht, die Alltagsbewegung steckt dort schon drin.',
  },
  quick: {
    likeYesterday_one: 'Wie gestern: 1 Eintrag übernehmen',
    likeYesterday_other: 'Wie gestern: {{count}} Einträge übernehmen',
    recent: 'Zuletzt',
    favorites: 'Favoriten',
    onePortion: '1 Portion',
    empty:
      'Noch nichts zum schnellen Eintragen — sobald du etwas protokolliert oder ein Gericht als Favorit markiert hast, steht es hier.',
    fromOff: 'aus Open Food Facts — Menge in Gramm unten',
    incomplete:
      'Unvollständige Nährwerte — so lässt es sich nicht eintragen. Lege das Lebensmittel in der Bibliothek an und ergänze die Werte von der Packung.',
    unpick: 'Anderes',
  },
  scan: {
    open: 'Strichcode scannen',
    preview: 'Kamerabild zum Scannen',
    hint: 'Strichcode der Packung ins Bild halten — er wird von selbst erkannt.',
    close: 'Scannen beenden',
    slow: 'Noch kein Code erkannt. Näher ran, gerade halten, gutes Licht — oder die Ziffern unter dem Strichcode ins Suchfeld tippen.',
    problem: {
      denied:
        'Die Kamera ist nicht erlaubt. In den iOS-Einstellungen bei Kraftwerk bzw. Safari die Kamera freigeben — oder die Ziffern unter dem Strichcode eintippen.',
      noCamera: 'Keine Kamera gefunden. Die Ziffern unter dem Strichcode eintippen.',
      failed: 'Die Kamera ließ sich nicht starten. Die Ziffern unter dem Strichcode eintippen.',
    },
  },
  lookup: {
    sourceLabel: 'Woher',
    source: { off: 'Packung (Open Food Facts)', bls: 'Grundnahrungsmittel (BLS)' },
    queryBls: 'Lebensmittel, z. B. „Apfel roh“',
    hintBls:
      'Der Bundeslebensmittelschlüssel (Max Rubner-Institut, CC BY 4.0) nennt Durchschnittswerte für unverarbeitete und typische Lebensmittel — mit Vitaminen und Mineralstoffen. Ein Treffer füllt nur das Formular.',
    query: 'Name oder Strichcode',
    search: 'Suchen',
    busy: 'Sucht …',
    hint: 'Open Food Facts ist eine offene, von Nutzern gepflegte Datenbank. Ein Treffer füllt nur das Formular — bitte mit der Packung vergleichen, dann speichern.',
    none: 'Nichts gefunden. Anderes Suchwort oder den Strichcode von der Packung probieren.',
    per100g: 'je 100 g: {{kcal}} · {{protein}} Protein',
    missing: 'k. A.',
    results: 'Treffer',
    codeUnknown: 'Strichcode {{code}} ist nicht in Open Food Facts.',
    createWithCode: 'Selbst anlegen — mit diesem Strichcode',
    incomplete: 'Unvollständig — fehlende Werte bitte von der Packung ergänzen.',
    problem: {
      offline: 'Ohne Verbindung zum Server geht die Suche nicht.',
      tooMany: 'Zu viele Suchen. Bitte später noch einmal.',
      unreachable: 'Open Food Facts antwortet gerade nicht.',
    },
  },
  import: {
    open: 'Von einer Webseite holen',
    url: 'Link zum Rezept',
    hint: 'Übernommen werden die Rezeptdaten, die die Seite für Suchmaschinen mitliefert — die meisten Rezeptseiten haben sie.',
    fetch: 'Abrufen',
    busy: 'Ruft ab …',
    take: 'Übernehmen',
    saving: 'Legt an …',
    summary: '{{ingredients}} Zutaten · {{steps}} Schritte',
    nutrition:
      'Nährwerte von der Seite je Portion: {{kcal}} kcal · {{protein}} g Eiweiß — mit Quelle übernommen. Ordnest du die Zutaten danach deinen Lebensmitteln zu, rechnet das Gericht selbst.',
    noNutrition:
      'Die Zutaten kommen als freie Zeilen ohne Nährwerte. Ordne sie danach deinen Lebensmitteln zu — dann rechnet das Gericht.',
    problem: {
      blocked: 'Diese Adresse lässt sich nicht abrufen.',
      noRecipe:
        'Auf dieser Seite stehen keine Rezeptdaten. Geraten wird nicht — lege das Gericht bitte von Hand an.',
      unreachable: 'Die Seite ist gerade nicht erreichbar.',
      refused:
        'Diese Seite lässt keine Abrufe von Servern zu. Lege das Gericht bitte von Hand an — oder versuch eine andere Rezeptseite.',
      tooMany: 'Zu viele Abrufe. Bitte später noch einmal.',
      offline: 'Ohne Verbindung zum Server geht das nicht.',
    },
  },
  cook: {
    prepareAsWritten: 'Bereitlegen (Mengen wie im Rezept)',
    open_one: 'Kochen · {{count}} Portion',
    open_other: 'Kochen · {{count}} Portionen',
    close: 'Beenden',
    noWakeLock: 'Dieses Gerät lässt den Bildschirm nicht an — er kann zwischendurch ausgehen.',
    prepare_one: 'Bereitlegen für {{count}} Portion',
    prepare_other: 'Bereitlegen für {{count}} Portionen',
    start: 'Los geht’s',
    stepOf: 'Schritt {{number}} von {{total}}',
    previous: 'Zurück',
    next: 'Weiter',
    finish: 'Fertig gekocht',
    howWasIt: 'Wie war’s?',
    rating: 'Bewertung',
    note: 'Für das nächste Mal',
    noteHint: 'z. B. weniger Salz, länger köcheln',
    saveNote: 'Notiz speichern',
    skipNote: 'Ohne Notiz beenden',
  },
  dish: {
    assign: '{{name}} zuordnen',
    assignHint: '„{{line}}" — welchem Lebensmittel entspricht das?',
    assignConfirm: 'Zuordnen',
    duplicate: 'Als Variante anlegen',
    variantName: '{{name}} (Variante)',
    share: 'An den Haushalt geben',
    shareHint:
      'Der andere bekommt eine eigene Kopie — samt fehlender Lebensmittel. Danach seid ihr unabhängig: Änderungen wandern nicht mit.',
    shareTo: 'An {{name}} geben',
    shared: '{{name}} hat jetzt eine Kopie.',
    shareFailed: 'Hat nicht geklappt — geht nur mit Verbindung zum Server.',
    editing: '{{name}} bearbeiten',
    basics: 'Grunddaten',
    saved: 'Gespeichert.',
    done: 'Fertig',
    image: 'Bild',
    imageOffline: 'Ohne Verbindung zum Server geht das Bild nicht hoch. Bitte später noch einmal.',
    imageTooLarge: 'Das Bild ließ sich nicht klein genug machen.',
    imageFailed: 'Das Bild wurde nicht angenommen. Bitte noch einmal.',
    imageLocked: 'Bilder gehen nur verschlüsselt hoch — erst dieses Gerät entsperren.',
    imageBusy: 'Lädt hoch …',
    imageChange: 'Bild ändern',
    imageAdd: 'Bild hinzufügen',
    imageRemove: 'Bild entfernen',
    addHow: 'Wie hinzufügen?',
    moveUp: '{{name}} nach oben',
    moveDown: '{{name}} nach unten',
    changeAmount: 'Menge von {{name}} ändern',
    removeNamed: '{{name}} entfernen',
    amount: 'Menge',
    unit: 'Einheit',
    equalsGrams: '= {{grams}} g',
    freeLine: 'Freie Zeile',
    freeLineHint: 'z. B. 1 Prise Salz',
    freeLineNote: 'Freie Zeilen haben keine Nährwerte und zählen nicht mit.',
    noSteps: 'Noch keine Schritte.',
    stepLabel: 'Schritt {{number}}',
    stepUp: 'Schritt {{number}} nach oben',
    stepDown: 'Schritt {{number}} nach unten',
    stepRemove: 'Schritt {{number}} entfernen',
    addStep: 'Schritt hinzufügen',
    note: 'Notiz',
    sourceUrl: 'Quelle als Link',
    add: {
      food: 'Aus der Bibliothek',
      newFood: 'Neues Lebensmittel',
      free: 'Freie Zeile',
    },
    search: 'Gericht suchen',
    filter: 'Nach Mahlzeit filtern',
    allSlots: 'Alle',
    favorite: 'Favorit',
    noMatch: 'Kein Gericht passt.',
    gone: 'Dieses Gericht gibt es nicht mehr.',
    perPortion: 'Je Portion',
    steps: 'Zubereitung',
    sourceLink: 'Rezept auf {{host}}',
    notes: 'Kochnotizen',
    ratingUp: 'gut',
    ratingDown: 'nicht so',
    deleteWarning: 'Das Gericht wird gelöscht. Was du schon gegessen hast, bleibt im Protokoll.',
    delete: 'Gericht löschen',
    back: 'Zurück',
    fewerPortions: 'Eine Portion weniger',
    morePortions: 'Eine Portion mehr',
    portions_one: '{{count}} Portion',
    portions_other: '{{count}} Portionen',
    noIngredients: 'Keine Zutaten hinterlegt.',
    noNutrition: 'ohne Nährwerte',
    actions: 'Was du mit dem Gericht machen kannst',
    eatToday: 'Heute gegessen',
    plan: 'In Wochenplan',
    shop: 'Fehlendes auf die Liste',
    noHousehold: 'Für die Einkaufsliste braucht es zuerst einen Haushalt (Reiter Einkauf).',
    addedToList_one: '1 Eintrag auf die Einkaufsliste gesetzt.',
    addedToList_other: '{{count}} Einträge auf die Einkaufsliste gesetzt.',
    nothingMissing: 'Es fehlt nichts — alles im Vorrat oder schon auf der Liste.',
    logged_one: '1 Portion eingetragen.',
    logged_other: '{{count}} Portionen eingetragen.',
    cannotLog: 'Ohne Nährwerte lässt sich das Gericht nicht eintragen.',
    howMuch: 'Wie viel?',
    logConfirm: 'Eintragen',
    planned: 'Eingeplant für {{day}}',
    day: 'Tag',
    meal: 'Mahlzeit',
    planConfirm: 'Einplanen',
  },
  password: {
    change: 'Passwort ändern',
    changeHint:
      'Danach sind alle anderen Geräte abgemeldet — dieses bleibt angemeldet. Passkeys gelten weiter.',
    current: 'Bisheriges Passwort',
    next: 'Neues Passwort (mind. {{min}} Zeichen)',
    repeat: 'Neues Passwort wiederholen',
    save: 'Passwort ändern',
    busy: 'Ändert …',
    changed: 'Passwort geändert. Andere Geräte sind abgemeldet.',
    failed: 'Hat nicht geklappt — geht nur mit Verbindung zum Server.',
    problem: {
      tooShort: 'Das neue Passwort braucht mindestens {{min}} Zeichen.',
      tooLong: 'Das neue Passwort ist zu lang.',
      mismatch: 'Die beiden neuen Passwörter stimmen nicht überein.',
      unchanged: 'Das neue Passwort ist dasselbe wie das bisherige.',
    },
    show: 'Passwort anzeigen',
    hide: 'Passwort verbergen',
  },
  passkeys: {
    heading: 'Passkeys',
    intro:
      'Anmelden ohne Passwort — bestätigt mit Face ID, Fingerabdruck oder der PIN des Geräts bzw. Passwortmanagers. Der Schlüssel bleibt dort; der Server kennt nur den öffentlichen Teil.',
    none: 'Noch kein Passkey eingerichtet.',
    offline: 'Die Liste gibt es nur mit Verbindung zum Server.',
    add: 'Passkey hinzufügen',
    name: 'Name (zum Wiedererkennen)',
    defaultName: 'Passkey',
    namePlaceholder: 'z. B. iPhone',
    password: 'Passwort zur Bestätigung',
    confirm: 'Einrichten',
    busy: 'Warte auf die Bestätigung am Gerät …',
    exists: 'Dieses Gerät hat schon einen Passkey für dein Konto.',
    failed: 'Hat nicht geklappt. Bitte noch einmal.',
    remove: 'Löschen',
    removeNamed: 'Passkey „{{name}}“ löschen',
    lastUsed: 'Zuletzt benutzt am {{date}}',
    created: 'Eingerichtet am {{date}}',
  },
  crash: {
    heading: 'Etwas ist schiefgegangen',
    screenHeading: 'Dieser Bereich ließ sich nicht anzeigen',
    safe: 'Deine Einträge liegen sicher auf dem Gerät — es ist nichts verloren. Neu laden hilft meistens.',
    reload: 'Neu laden',
    details: 'Technische Einzelheiten',
  },
  theme: {
    heading: 'Darstellung',
    system: 'Gerät',
    light: 'Hell',
    dark: 'Dunkel',
  },
  sync: {
    done: 'Alles synchronisiert',
    syncing: 'Synchronisiere …',
    pending_one: '1 Änderung wartet',
    pending_other: '{{count}} Änderungen warten',
    offline_one: 'Offline · 1 Änderung wartet',
    offline_other: 'Offline · {{count}} Änderungen warten',
    failed_one: '1 Änderung abgelehnt',
    failed_other: '{{count}} Änderungen abgelehnt',
    error: 'Synchronisation fehlgeschlagen',
    now: 'Jetzt',
    retry: 'Erneut versuchen',
    reason: 'Grund: {{reason}}',
    unreachable_one: 'Server nicht erreichbar · 1 Änderung wartet auf dem Gerät',
    unreachable_other: 'Server nicht erreichbar · {{count}} Änderungen warten auf dem Gerät',
    serverError: 'Server-Fehler (HTTP {{status}}) — Änderungen bleiben auf dem Gerät',
    unreachableShort: 'Nicht erreichbar',
    updateRequired_one: 'Neue Version nötig · 1 Änderung wartet auf dem Gerät.',
    updateRequired_other: 'Neue Version nötig · {{count}} Änderungen warten auf dem Gerät.',
    updateRequiredShort: 'Aktualisieren',
    serverErrorShort: 'Server-Fehler {{status}}',
    heldEmpty_one: '1 Änderung zurückgehalten · ohne Inhalt',
    heldEmpty_other: '{{count}} Änderungen zurückgehalten · ohne Inhalt',
    heldEmptyShort: 'Zurückgehalten',
    heldEmptyHint:
      'Sie hätten beim Server einen Eintrag geleert und bleiben deshalb auf dem Gerät. Trag den Eintrag neu ein, dann geht die neue Fassung hinaus.',
  },
  supplements: {
    withMeal: 'Zur Mahlzeit',
    withMealFor: '{{name}}: zur Mahlzeit',
    noMeal: 'an keine Mahlzeit gebunden',
    atMeal: 'zum {{slot}}',
    heading: 'Supplements',
    name: 'Name',
    time: 'Uhrzeit',
    add: 'Hinzufügen',
    remove: 'Löschen',
    removeNamed: '{{name}} löschen',
    empty: 'Noch nichts angelegt.',
    noTime: 'ohne feste Zeit',
  },
  supplementLib: {
    intro:
      'Form, Menge je Einnahme (von der Packung) und wann. Abgehakt wird im Tag und auf „Heute“.',
    new: 'Neues Supplement',
    scan: 'Strichcode scannen',
    scanKnown: '{{name}} ist schon in der Bibliothek.',
    scanFound: 'Gefunden — bitte mit der Packung vergleichen.',
    scanUnknown:
      'Nicht gefunden. Name von der Packung eintragen — beim nächsten Scan erkennt die App es.',
    scanTooMany: 'Zu viele Suchen gerade — der Code ist trotzdem eingetragen.',
    sourcePackage: 'Packung',
    editNamed: '{{name}} bearbeiten',
    form: 'Form',
    forms: { powder: 'Pulver', capsule: 'Kapsel/Tablette', liquid: 'Öl/Flüssig' },
    amount: 'Menge',
    unit: 'Einheit',
    pickFormFirst: 'Erst die Form wählen — sie bestimmt die Einheit.',
    amountInvalid: 'Die Menge ist keine Zahl.',
    noAmount: 'Menge offen',
    content: 'Gehalt je Einheit (von der Packung)',
    contentExample: 'z. B. 1 Kapsel = 1000 IE Vitamin D3',
    times: 'Uhrzeiten',
    timeNumber: 'Uhrzeit {{number}}',
    removeTime: '{{time}} entfernen',
    addTime: 'Weitere Uhrzeit',
    weekdays: 'Wochentage',
    weekday: { 1: 'Mo', 2: 'Di', 3: 'Mi', 4: 'Do', 5: 'Fr', 6: 'Sa', 7: 'So' },
    daily: 'täglich',
    dailyHint: 'Keiner gewählt: täglich.',
    barcode: 'Strichcode',
    barcodeInvalid: 'Ein Strichcode hat 8 bis 14 Ziffern.',
    source: 'Quelle',
    save: 'Speichern',
  },
  acknowledge: {
    dueAt: 'Fällig um {{time}}',
    unknown: 'Einnahme',
    alreadyTaken: 'Bereits um {{time}} abgehakt.',
    alreadySkipped: 'Um {{time}} für heute übersprungen.',
    later: 'Nur nachgeschaut — zurück zur App',
    continue: 'Weiter zur App',
  },
  today: {
    moreToday_one: '+1 weitere heute',
    moreToday_other: '+{{count}} weitere heute',
    hideRest: 'Weitere zuklappen',
    heading: 'Heute fällig',
    next: 'Als Nächstes fällig',
    after: 'Danach: {{name}} um {{time}}',
    nothingOpen: 'Heute nichts mehr offen.',
    empty: 'Für heute steht nichts an.',
    openCount_one: '1 offen',
    openCount_other: '{{count}} offen',
    take: 'Genommen',
    takeNamed: '{{name}} als genommen abhaken',
    skip: 'Heute nicht',
    skipNamed: '{{name}} für heute überspringen',
    done: 'Genommen',
    skipped: 'Heute übersprungen',
    ackFrom: 'abhaken ab {{time}}',
    preparing: 'wird eingerichtet …',
  },
  push: {
    heading: 'Mitteilungen auf diesem Gerät',
    intro: 'Damit die App sich meldet, auch wenn sie geschlossen ist.',
    enable: 'Benachrichtigungen erlauben',
    enabling: 'Richte ein …',
    enabled: 'Benachrichtigungen sind aktiv.',
    maxActions_one: 'Diese Umgebung erlaubt 1 Aktions-Knopf in einer Benachrichtigung.',
    maxActions_other: 'Diese Umgebung erlaubt {{count}} Aktions-Knöpfe in einer Benachrichtigung.',
    maxActionsUnknown:
      'Diese Umgebung macht keine Angabe zu Aktions-Knöpfen — auf iOS ist das normal. Antippen der Benachrichtigung funktioniert immer.',
    denied:
      'Benachrichtigungen sind blockiert. Das lässt sich nur in den Einstellungen des Geräts wieder ändern.',
    needsInstall:
      'Auf dem iPhone gibt es Benachrichtigungen nur, wenn die App über „Teilen → Zum Home-Bildschirm" installiert ist. Danach hier erneut öffnen.',
    unsupported: 'Dieser Browser kann keine Benachrichtigungen empfangen.',
    notConfigured: 'Auf diesem Server ist Push noch nicht eingerichtet.',
    error: 'Einrichten fehlgeschlagen: {{message}}',
  },
  status: {
    heading: 'Systemzustand',
    checking: 'Prüfe Verbindung …',
    ok: 'Verbunden',
    degraded: 'Datenbank antwortet nicht',
    offline: 'Kein Server erreichbar',
    database: 'Datenbank',
    retry: 'Erneut prüfen',
  },
  training: {
    tabs: {
      label: 'Trainingsbereich',
      overview: 'Übersicht',
      exercises: 'Übungen',
      plans: 'Pläne',
      progress: 'Fortschritt',
    },
    overview: {
      activePlan: 'Laufender Plan',
      noActivePlan: 'Kein Plan ist als laufend gesetzt. Wähle einen aus oder leg einen neuen an.',
      toPlans: 'Zu den Plänen',
      planWithoutDays: 'Dieser Plan hat noch keine Trainingstage.',
      nextUp: 'Ist als Nächstes dran',
      start: 'Starten',
      resume: 'Einheit läuft — weiter',
      forgotten: '„{{title}}“ läuft seit {{date}} — vergessen zu beenden?',
      forgottenWhy:
        'Beendet wird beim letzten eingetragenen Satz, nicht jetzt — sonst zählte die Einheit Tage.',
      forgottenEnd: 'Beim letzten Satz beenden',
      forgottenResume: 'Doch weitermachen',
      freeSession: 'Freie Einheit starten',
      freeSessionHeading: 'Ohne Plan',
      freeSessionWhy: 'Übungen wählst du unterwegs.',
      freeSessionTitle: 'Freies Training',
      recent: 'Letzte Einheiten',
      noSessions: 'Noch keine Einheit aufgezeichnet.',
      unfinished: 'nicht beendet',
    },
    session: {
      startedAt: 'Begonnen um {{time}}',
      finish: 'Einheit beenden',
      noExercises: 'Noch keine Übung in dieser Einheit. Unten hinzufügen.',
      recent: 'Zuletzt trainiert',
      addExercise: 'Übung hinzufügen',
      addExercisePlaceholder: 'Übung wählen …',
      swapToday: 'Nur heute tauschen',
      swapTodayWhy: 'Gerät belegt oder etwas zwickt? Der Plan bleibt, wie er ist.',
      swapTodayPlaceholder: 'Andere Übung …',
      swappedFrom: 'Heute statt {{name}}',
      swapBack: 'Zurück zu {{name}}',
      target: '{{sets}} Sätze · {{min}}–{{max}} Wdh.',
      targetSetsOnly: '{{sets}} Sätze',
      details: 'Details',
      lastTime: 'Letztes Mal ({{date}}):',
      noHistory: 'Noch keine Werte — dies ist das erste Mal.',
      warmup: 'Aufwärmen',
      superset: 'Supersatz — abwechselnd, Pause erst nach der Runde',
      supersetNext: 'Ohne Pause weiter mit {{name}}',
      deleteSet: 'Löschen',
      deleteSetNamed: 'Satz {{index}} löschen',
      bodyWeightLabel: 'Körpergewicht heute (kg)',
      bodyWeightWhy:
        'Wird für Klimmzüge und Dips gebraucht und beim Satz mitgeschrieben — sonst wäre jede alte Schätzung später falsch.',
      bodyWeightSave: 'Übernehmen',
      suggestion: {
        increase:
          'Vorschlag: {{weight}} kg (+{{increment}}) — letztes Mal alle Sätze am oberen Ende.',
        hold: 'Vorschlag: {{weight}} kg halten.',
        deload: 'Vorschlag: {{weight}} kg — zwei Einheiten unterhalb der Spanne.',
      },
    },
    set: {
      weight: 'Gewicht (kg)',
      addedWeight: 'Zusatz (kg)',
      reps: 'Wdh.',
      seconds: 'Sekunden',
      distance: 'Meter',
      side: 'Seite',
      left: 'Links',
      right: 'Rechts',
      warmup: 'Aufwärmsatz',
      log: 'Satz eintragen',
      less: '{{field}} verringern',
      more: '{{field}} erhöhen',
    },
    rest: {
      running: 'Pause läuft',
      done: 'Pause vorbei.',
      skip: 'Überspringen',
      dismiss: 'Ausblenden',
      pushOn: 'Das Telefon meldet sich zum Pausenende — auch bei ausgeschaltetem Bildschirm.',
      pushOff:
        'Mitteilungen sind aus: Zum Pausenende meldet sich das Telefon nicht. Einschalten unter Einstellungen.',
      pushFailed:
        'Ohne Netz: keine Mitteilung zum Pausenende. Der Timer läuft trotzdem — nur nicht in der Tasche.',
    },
    library: {
      muscles: 'Muskeln',
      allMuscles: 'Alle',
      heading: 'Übungen',
      intro:
        'Deine Übungen — der Startbestand wurde beim Anlegen des Kontos kopiert und ist vollständig änderbar.',
      new: 'Neue Übung',
      search: 'Suche',
      equipment: 'Gerät',
      anyEquipment: 'Alle Geräte',
      empty: 'Keine Übung gefunden.',
      addVariant: 'Variante',
      edit: 'Bearbeiten',
      save: 'Speichern',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      deleteHint:
        'Löschen entfernt nur diese Übung. Varianten darunter bleiben erhalten — an ihnen hängt dein Verlauf.',
      variantOf: 'Neue Variante von {{name}}',
      best: '≈ {{kg}} kg',
      sessions_one: '1 Einheit',
      sessions_other: '{{count}} Einheiten',
      untrained: 'noch nicht trainiert',
    },
    detail: {
      back: 'Übungen',
      gone: 'Diese Übung gibt es nicht mehr.',
      variantOf: 'Variante von {{name}}',
      newVariant: 'Neue Variante',
      progress: 'Fortschritt',
      noSets: 'Noch kein Satz eingetragen.',
      recent: 'Letzte Einheiten',
      guide: 'Ausführung',
      noCues: 'Keine Hinweise hinterlegt.',
      variants: 'Varianten',
    },
    art: {
      label: '{{name}}: Anfangs- und Endstellung',
      none: 'Kein Bild hinterlegt.',
      approx: 'Ähnliche Ausführung.',
      credit: 'Zeichnung:',
      source: 'Everkinetic',
      license: 'CC BY-SA 4.0',
      modified: 'verändert',
    },
    exercise: {
      name: 'Name',
      variantLabel: 'Kurzform',
      trackingMode: 'Aufzeichnung',
      equipment: 'Gerät',
      movementPattern: 'Bewegungsmuster',
      bodyRegion: 'Bereich',
      primaryMuscles: 'Zielmuskeln',
      secondaryMuscles: 'Beteiligt',
      defaultSets: 'Sätze',
      repMin: 'Wdh. von',
      repMax: 'bis',
      incrementKg: 'Stufe (kg)',
      restSeconds: 'Pause (s)',
      isCompound: 'Grundübung',
      isUnilateral: 'Einseitig',
      isFavorite: 'Favorit',
      cues: 'Hinweise',
      cuesHint: 'Eine Zeile je Hinweis.',
      cuesDisclaimer: 'Kurzmerker, kein Techniktraining.',
      inheritedFrom: 'Hinweise vom Grundtyp {{name}}',
      setupNotes: 'Einstellungen',
      setupPlaceholder: 'Gerät 7, Sitzhöhe 4, Pin auf 3',
      note: 'Notiz',
      videos: 'Videos',
      videoLabel: 'Beschriftung',
      videoUrl: 'Adresse (https)',
      videoStart: 'Start (s)',
      videoDefaultLabel: 'Technik',
      addVideo: 'Video hinzufügen',
      removeVideoNamed: 'Video {{label}} entfernen',
      videoInvalid: 'Nur https-Adressen werden gespeichert.',
      videoPrivacy:
        'Videos werden verlinkt, nicht eingebettet — kein fremder Code in der App, und du siehst vorher, wohin es geht.',
      videoNeedsNetwork: 'Videos brauchen eine Verbindung — im Funkloch nicht abrufbar.',
      noVideo: 'Kein Video hinterlegt.',
      videoCount_one: '1 Video hinterlegt',
      videoCount_other: '{{count}} Videos hinterlegt',
      unknownHost: 'unbekannte Quelle',
    },
    plans: {
      starterNew_one: 'Es gibt eine neue Plan-Vorlage, etwa Calisthenics 3×.',
      starterNew_other: 'Es gibt {{count}} neue Plan-Vorlagen, etwa Calisthenics 3×.',
      starterFetch: 'Neue Vorlagen holen',
      starterFailed: 'Die Vorlagen kamen nicht an. Später noch einmal versuchen.',
      heading: 'Pläne',
      intro:
        'Ein Plan besteht aus Trainingstagen, ein Trainingstag aus Übungen. Sätze und Spanne gelten nur hier — die Übung selbst bleibt unverändert.',
      new: 'Neuer Plan',
      newPlan: 'Name des Plans',
      create: 'Plan anlegen',
      empty: 'Noch kein Plan angelegt.',
      active: 'laufend',
      activate: 'Als laufend setzen',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      deleteNamed: 'Plan {{name}} löschen',
      newDay: 'Neuer Trainingstag',
      newDayPlaceholder: 'Oberkörper A',
      addDay: 'Tag hinzufügen',
      noDays: 'Noch kein Trainingstag.',
      dayName: 'Name des Trainingstags',
      deleteDay: 'Tag löschen',
      deleteDayNamed: 'Trainingstag {{name}} löschen',
      addExercise: 'Übung hinzufügen',
      pickExercise: 'Übung wählen …',
      unknownExercise: 'Übung nicht gefunden',
      compound: 'Grundübung — bleibt vorn, wird nicht rotiert',
      superset: 'Supersatz mit der Übung davor',
      sets: 'Sätze',
      repMin: 'von',
      repMax: 'bis',
      rest: 'Pause',
      moveUp: 'Nach oben',
      moveDown: 'Nach unten',
      removeEntry: 'Eintrag entfernen',
      swap: 'Tauschen',
      swapPlaceholder: 'Andere Übung …',
      sameFamily: 'Gleiche Familie',
      allExercises: 'Alle Übungen',
    },
    progress: {
      historySummary:
        '{{name}}: geschätztes Maximum von {{first}} auf {{last}} kg über {{days}} Trainingstage',
      heading: 'Fortschritt',
      streak: 'Wochen in Folge trainiert',
      streakValue_one: '{{count}} Woche',
      streakValue_other: '{{count}} Wochen',
      streakWhy:
        'Konsistenz ist das, was sich in Woche 3 beeinflussen lässt — deshalb steht sie hier zuerst.',
      weeklyVolume: 'Wochenvolumen',
      sessions_one: '1 Einheit',
      sessions_other: '{{count}} Einheiten',
      barLabel: 'Woche ab {{week}}: {{kg}} kg',
      uncounted_one: '1 Satz ohne Volumen in kg (Zeit oder Strecke) — nicht eingerechnet.',
      uncounted_other:
        '{{count}} Sätze ohne Volumen in kg (Zeit oder Strecke) — nicht eingerechnet.',
      oneRepMax: 'Geschätztes Maximum',
      oneRepMaxWhy:
        'Schätzung nach Epley aus Gewicht und Wiederholungen. Zum Vergleich mit dir selbst, nicht als Bestwert.',
      estimate: '{{best}} kg · {{sets}} Sätze',
      noEstimate: 'keine Schätzung möglich',
    },
    mode: {
      weightReps: 'Gewicht × Wdh.',
      bodyweightReps: 'Körpergewicht × Wdh.',
      weightedBodyweight: 'Körpergewicht + Zusatz',
      timeHold: 'Zeit halten',
      distanceTime: 'Strecke und Dauer',
    },
    equipment: {
      barbell: 'Langhantel',
      dumbbell: 'Kurzhantel',
      machine: 'Maschine',
      cable: 'Kabelzug',
      bodyweight: 'Körpergewicht',
      kettlebell: 'Kettlebell',
      band: 'Band',
      other: 'Sonstiges',
    },
    pattern: {
      push: 'Drücken',
      pull: 'Ziehen',
      squat: 'Kniebeuge',
      hinge: 'Hüftstreckung',
      lunge: 'Ausfallschritt',
      core: 'Rumpf',
      carry: 'Tragen',
      cardio: 'Ausdauer',
      isolation: 'Isolation',
    },
    region: {
      upper: 'Oberkörper',
      lower: 'Unterkörper',
      core: 'Rumpf',
      fullBody: 'Ganzkörper',
    },
    muscleGroup: {
      chest: 'Brust',
      back: 'Rücken',
      shoulders: 'Schultern',
      arms: 'Arme',
      legs: 'Beine',
      core: 'Rumpf',
      cardio: 'Ausdauer',
    },
    muscle: {
      chest: 'Brust',
      back: 'Rücken',
      lats: 'Latissimus',
      shoulders: 'Schultern',
      rearDelts: 'hintere Schulter',
      biceps: 'Bizeps',
      triceps: 'Trizeps',
      forearms: 'Unterarme',
      quads: 'Oberschenkel vorn',
      hamstrings: 'Oberschenkel hinten',
      glutes: 'Gesäß',
      calves: 'Waden',
      core: 'Rumpf',
      lowerBack: 'unterer Rücken',
      cardio: 'Ausdauer',
    },
  },
  nutrition: {
    tabs: {
      label: 'Ernährungsbereich',
      day: 'Tag',
      week: 'Woche',
      library: 'Bibliothek',
    },
    macroShort: {
      kcal: 'kcal',
      protein: 'Protein',
      carbs: 'Kohlenh.',
      fat: 'Fett',
    },
    macro: {
      kcal: 'Kalorien',
      protein: 'Protein',
      carbs: 'Kohlenhydrate',
      fat: 'Fett',
    },
    slot: {
      breakfast: 'Frühstück',
      lunch: 'Mittagessen',
      pre: 'Pre-Workout',
      post: 'Post-Workout',
      dinner: 'Abendessen',
      snack: 'Snack',
      snack2: 'Snack 2',
      snack3: 'Snack 3',
      snack4: 'Snack 4',
    },
    day: {
      supplementsAsk: 'Dazu genommen?',
      supplementsAt: 'Supplements',
      supplementTaken: 'genommen',
      supplementSkipped: 'heute nicht',
      supplementTakeNamed: '{{name}} genommen',
      heading: 'Tagesprotokoll',
      today: 'heute',
      previous: 'Vorheriger Tag',
      next: 'Nächster Tag',
      slotEmpty: 'nichts eingetragen',
      change: 'Ändern',
      changePlannedNamed: 'Menge von {{name}} ändern',
      plannedPortionsShort_one: '1 Portion',
      plannedPortionsShort_other: '{{amount}} Portionen',
      fromPlan: 'geplant',
      skipPlannedNamed: '{{name}} auslassen',
      plannedSkipped: 'ausgelassen',
      notCounted: 'zählt nicht',
      count: 'Zählen',
      restorePlannedNamed: '{{name}} wieder zählen',
      plannedWithoutValues:
        'Ohne Nährwerte (oder ohne Menge) kann es nicht zählen — am Gericht oder Lebensmittel ergänzen.',
      macrosHeading: 'Tagesstand',
      plannedUnknown: 'Eintrag ohne Gericht',
      unplanNamed: '{{name}} aus dem Plan nehmen',
      plannedGrams: '{{name}}, {{grams}} g',
      plannedPortions: '{{name}}, {{count}} Portionen',
      add: 'Eintragen',
      log: 'Gegessen',
      plan: 'Planen',
      removeNamed: '{{name}} aus dem Protokoll entfernen',
      choose: 'Auswählen …',
      pickRecipe: 'Gericht',
      pickFood: 'Lebensmittel',
      freeLabel: 'Was war es?',
      freeHint: 'Für auswärts gegessenes — geschätzt ist besser als gar nicht erfasst.',
      recipeWithoutMacros:
        'Dieses Gericht hat keine Nährwerte. Trag sie am Gericht ein oder füge Zutaten hinzu — ein Eintrag mit 0 kcal sähe aus wie eine Angabe.',
      photo: {
        start: 'Foto schätzen',
        pick: 'Foto aufnehmen oder wählen',
        consentHeading: {
          anthropic: 'Foto an einen KI-Dienst senden?',
          ollama: 'Foto auf eurem Server schätzen lassen?',
        },
        consent: {
          anthropic:
            'Zum Schätzen geht dieses eine Foto an einen KI-Dienst (Anthropic). Er verarbeitet es nur für die Schätzung; Kraftwerk speichert das Foto nicht. Dieser Weg geht an der Ende-zu-Ende-Verschlüsselung vorbei.',
          ollama:
            'Das Foto wird auf eurem eigenen Server geschätzt und nicht gespeichert; es verlässt den Server nicht. Dafür sieht der Server dieses eine Foto kurz — an der Ende-zu-Ende-Verschlüsselung vorbei.',
        },
        consentResult:
          'Geschätzt wird im Hintergrund, meist in 1–3 Minuten — du kannst die App solange verlassen. Das Ergebnis ist eine Schätzung und kann deutlich danebenliegen; eingetragen wird erst, wenn du es geprüft hast.',
        send: 'Schätzen lassen',
        cancel: 'Nicht senden',
        preparing: 'Foto wird verkleinert …',
        busy: 'Wird gesendet …',
        resultHeading: 'Vorschlag aus dem Foto (KI)',
        resultHint: 'Kann deutlich danebenliegen — bitte prüfen und anpassen.',
        today: {
          heading: 'Foto-Schätzung',
          waiting_one: '{{count}} Foto wird geschätzt …',
          waiting_other: '{{count}} Fotos werden geschätzt …',
          ready_one: '{{count}} Vorschlag wartet auf dich.',
          ready_other: '{{count}} Vorschläge warten auf dich.',
          failed_one: '{{count}} Schätzung hat nicht geklappt.',
          failed_other: '{{count}} Schätzungen haben nicht geklappt.',
          open: 'Zum Tag',
        },
        pending: {
          heading: 'Foto wird geschätzt …',
          hint: 'Meist 1–3 Min. Du kannst die App verlassen — eine Mitteilung sagt Bescheid.',
          unsent: 'Wartet auf Verbindung — wird gesendet, sobald der Server erreichbar ist.',
          queued: 'An {{position}}. Stelle in der Warteschlange.',
          running: 'Wird gerade geschätzt.',
          locked:
            'Der Vorschlag ist da, aber verschlüsselt. Entsperre die Verschlüsselung auf diesem Gerät, dann erscheint er hier.',
          failedHeading: 'Die Schätzung hat nicht geklappt',
          noPhoto:
            'Das Foto liegt auf dem Gerät, das es gesendet hat — erneut senden geht nur dort.',
          dish: 'Gericht: {{dish}}',
          values:
            '{{kcal}} kcal · {{protein}} g Protein · {{carbs}} g Kohlenhydrate · {{fat}} g Fett',
          accept: 'Passt',
          adjust: 'Anpassen',
          discard: 'Verwerfen',
          resend: 'Erneut senden',
          save: 'So eintragen',
          slotOpen: 'Schätzung offen',
          atLeast: 'mindestens',
          dayOpen_one: 'Enthält {{count}} offene Schätzung — die Summe ist mindestens so hoch.',
          dayOpen_other: 'Enthält {{count}} offene Schätzungen — die Summe ist mindestens so hoch.',
        },
        portion: 'Angenommen: {{portion}}',
        confidence: {
          low: 'Sicherheit: gering',
          medium: 'Sicherheit: mittel',
          high: 'Sicherheit: hoch',
        },
        discard: 'Schätzung verwerfen',
        badge: 'geschätzt (Foto, KI)',
        note: 'Angenommen: {{portion}}',
        dayContains: 'Enthält Schätzungen per Foto (KI) — die Summe ist ungefähr.',
        error: {
          offline: 'Keine Verbindung — die Schätzung braucht den Server.',
          disabled: 'Die Schätzung per Foto ist auf diesem Server nicht eingerichtet.',
          child: 'Für Kinderkonten gibt es die Schätzung per Foto nicht.',
          not_food: 'Auf dem Foto ist kein Essen zu erkennen. Ein anderes Foto versuchen?',
          refused: 'Der KI-Dienst hat die Schätzung abgelehnt. Bitte selbst schätzen.',
          invalid:
            'Die Antwort des KI-Diensts war unbrauchbar. Noch einmal versuchen oder selbst schätzen.',
          upstream: 'Der KI-Dienst ist gerade nicht erreichbar. Später noch einmal versuchen.',
          rate: 'Für heute sind genug Fotos geschätzt. Bitte selbst eintragen.',
          tooLarge: 'Das Foto ist zu groß.',
          photo: 'Das Foto ließ sich nicht öffnen.',
          unknown: 'Die Schätzung ist fehlgeschlagen.',
          aborted:
            'Der Server wurde neu gestartet, bevor das Foto dran war — es lag nur in seinem Speicher. Bitte erneut senden.',
          busy: 'Gerade warten zu viele Fotos. Bitte später erneut senden.',
          identity:
            'Für das verschlüsselte Ergebnis fehlt noch das Schlüsselpaar dieses Kontos. Entsperre die Verschlüsselung und sende erneut.',
        },
      },
      mode: {
        quick: 'Schnell',
        recipe: 'Gericht',
        food: 'Lebensmittel',
        free: 'Frei',
      },
    },
    week: {
      heading: 'Wochenplan',
      otherSlots: 'Andere Slots',
      intro:
        'Die nächsten sieben Tage. Was du hier oder im Tag planst, steht an beiden Stellen und kommt mit „Aus dem Wochenplan“ auf die Einkaufsliste. Geplantes zählt im Tag als gegessen — dort lässt du aus, was nicht stattfand.',
      add: 'Planen',
      plan: 'Eintragen',
      empty: 'Nichts geplant.',
      remove: 'Aus dem Plan nehmen',
      supplements: 'Supplements: {{list}}',
    },
    library: {
      searchFoods: 'Suche',
      noFoodMatch: 'Kein Lebensmittel passt zur Suche.',
      foodLine: '{{kcal}} kcal · E {{protein}} · K {{carbs}} · F {{fat}} g je 100 g',
      heading: 'Bibliothek',
      recipes: 'Gerichte',
      foods: 'Lebensmittel',
      supplements: 'Supplements',
      recipesIntro:
        'Deine Standardgerichte. Der Startbestand stammt aus dem Prototyp — jede Zeile ist änderbar.',
      foodsIntro:
        'Nährwerte je 100 g, so wie sie auf der Packung stehen. Daraus lassen sich Gerichte rechnen.',
      newRecipe: 'Neues Gericht',
      newFood: 'Neues Lebensmittel',
      noRecipes: 'Noch kein Gericht angelegt.',
      noFoods:
        'Noch kein Lebensmittel angelegt. Die App bringt bewusst keine mit — erfundene Nährwerte sähen aus wie geprüfte Daten.',
      edit: 'Bearbeiten',
      save: 'Speichern',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      deleteNamed: '{{name}} löschen',
    },
    recipe: {
      name: 'Name',
      slot: 'Slot',
      portions: 'Portionen',
      items: 'Zutatenzeile',
      prepNote: 'Am Vorabend vorbereiten',
      prepNoteHint: 'z. B. Hafer einweichen',
      prepNoteShown: 'Vorabend: {{note}}',
      ingredients: 'Zutaten',
      noIngredients: 'Keine Zutaten — es gelten die eingetragenen Werte.',
      ingredientsWin:
        'Dieses Gericht rechnet aus seinen Zutaten. Eingetragene Werte gelten erst wieder, wenn keine Zutat mehr da ist.',
      needFoods: 'Zum Rechnen braucht es zuerst Lebensmittel in der Bibliothek.',
      food: 'Lebensmittel',
      pickFood: 'Auswählen …',
      grams: 'Gramm',
      addIngredient: 'Hinzufügen',
      removeIngredient: 'Zutat entfernen',
      unknownFood: 'Lebensmittel gelöscht',
      fromIngredients: 'aus Zutaten gerechnet',
      entered: 'eingetragen',
      noMacros: 'Keine Nährwerte hinterlegt',
      source: 'Quelle: {{note}}',
      kcalMismatch:
        'Aus den Makros ergeben sich {{computed}} kcal. Kleine Abweichungen sind normal — größere sind meist ein Tippfehler.',
    },
    food: {
      portionName: 'Portion (Name)',
      portionNameHint: 'z. B. Scheibe',
      portionGrams: 'Gramm je Portion',
      name: 'Name',
      brand: 'Marke',
      per100g: 'je 100 g',
      per100gHint: 'Alle Werte je 100 g — genau so, wie sie auf der Packung stehen.',
      findHeading: 'Lebensmittel finden',
      manual: 'Selbst eintragen',
      findAgain: 'Anders suchen',
      byHand: 'Von Hand — Werte von der Packung abschreiben.',
      withCode: 'Strichcode {{code}} wird mitgespeichert — beim nächsten Scannen ist es dann da.',
      fromSource: {
        off: 'Aus Open Food Facts — bitte mit der Packung vergleichen, dann speichern.',
        bls: 'Aus dem BLS (Durchschnittswerte) — bei Bedarf anpassen, dann speichern.',
      },
      source: 'Quelle',
      sourcePackage: 'Verpackung',
      noSource: 'Keine Quelle angegeben.',
      category: 'Regal im Laden',
    },
    targets: {
      heading: 'Zielwerte fehlen',
      intro:
        'Ohne Ziel zählt die App nur Summen. Persönliche Zielwerte schlägt sie vor, sobald sie Größe, Gewicht, Alter, Alltag und Ziel kennt.',
      personal: 'Angaben eintragen',
      manual: 'Eigene Zielwerte eintragen',
      save: 'Übernehmen',
      noProfile: 'Kein Profil auf diesem Gerät — bitte erst synchronisieren.',
      teenIntro:
        'Deine Ziele setzt du selbst — zum Beispiel mit deinem Trainer. Für Jugendliche schlägt Kraftwerk keine Werte vor.',
    },
    rules: {
      heading: 'Faustregeln',
      source: 'Allgemeine Richtwerte, keine Verordnung — die App protokolliert nur.',
    },
  },
  review: {
    trends: 'Verlauf · {{count}} Wochen',
    trendWeight: 'Gewicht (Wochenschnitt)',
    trendProtein: 'Protein (Ø je Tag)',
    trendVolume: 'Trainingsvolumen',
    trendSupplements: 'Supplements genommen',
    trendSummary: '{{label}}: von {{first}} auf {{last}}, {{weeks}} Wochen mit Wert',
    trendNone: '{{label}}: noch keine Werte',
    trendTooFew: 'Noch zu wenige Wochen mit Wert für eine Linie.',
    range: 'Woche {{from}} – {{to}}',
    nutrition: 'Essen',
    noFood: 'Diese Woche nichts protokolliert — keine Angabe.',
    avgProtein: 'g Protein im Schnitt',
    avgKcal: 'Ø {{kcal}} kcal',
    daysLogged_one: 'an {{count}} Tag protokolliert',
    daysLogged_other: 'an {{count}} Tagen protokolliert',
    proteinGoal_one: 'Proteinziel an {{count}} Tag erreicht',
    proteinGoal_other: 'Proteinziel an {{count}} Tagen erreicht',
    training: 'Training',
    sessions_one: 'Einheit',
    sessions_other: 'Einheiten',
    previous: 'Vorwoche {{value}}',
    volume: '{{kg}} kg Volumen',
    supplements: 'Supplements',
    noIntakes: 'Keine fälligen Einnahmen.',
    taken: 'genommen ({{taken}} von {{due}})',
    skipped_one: '{{count}} übersprungen',
    skipped_other: '{{count}} übersprungen',
    weight: 'Gewicht',
  },
  coach: {
    heading: 'KI-Coach',
    intro:
      'Ein KI-Modell schaut auf deine Zahlen der letzten Wochen und antwortet mit Beobachtungen und Fragen. Du siehst vorher genau, was gesendet wird.',
    open: 'Wochen mit dem KI-Coach besprechen',
    weeks: 'Zeitraum',
    weekOption_one: '{{count}} Woche',
    weekOption_other: '{{count}} Wochen',
    noData: 'Für diesen Zeitraum gibt es noch zu wenige Einträge — es gibt nichts zu besprechen.',
    notice: {
      heading: {
        ollama: 'Das geht an euren Server und wird nicht gespeichert',
        anthropic: 'Das geht über euren Server an Anthropic',
      },
      body: {
        ollama:
          'Die Zusammenfassung unten geht an euren eigenen Server, das Modell läuft dort. Sie verlässt ihn nicht und wird nicht gespeichert. Für die Antwort liest der Server sie kurz — an der Verschlüsselung vorbei.',
        anthropic:
          'Die Zusammenfassung unten geht über euren Server an Anthropic, einen Dienst außerhalb. Euer Server speichert sie nicht; was Anthropic damit tut, regeln dessen Bedingungen. Für die Antwort ist sie lesbar — an der Verschlüsselung vorbei.',
      },
    },
    preview: {
      range: 'Zeitraum {{from}} – {{to}}',
      none: 'keine Angabe',
      training: 'Training',
      sessions_one: '{{count}} Einheit · je Woche {{perWeek}}',
      sessions_other: '{{count}} Einheiten · je Woche {{perWeek}}',
      plan: 'Geplant {{planned}} · erledigt {{done}} · verpasst {{missed}} · abgesagt {{cancelled}}',
      noPlan: 'Keine Trainingstage geplant — keine Angabe zu verpassten Terminen',
      missedBy: 'Verpasst nach Wochentag: {{list}}',
      trainingDays: 'Deine Trainingstage: {{list}}',
      noTrainingDays: 'Keine festen Trainingstage',
      volume: 'Volumen je Woche (kg × Wdh.): {{list}}',
      exercises: 'Übungen (Einheiten): {{list}}',
      noExercises: 'Keine Übungen mit Sätzen',
      rating: 'Eigene Bewertung der Einheiten Ø {{value}}',
      nutrition: 'Essen und Wasser',
      daysLogged: 'An {{logged}} von {{days}} Tagen eingetragen',
      avgFood: 'Ø {{kcal}} kcal · Ø {{protein}} g Protein (an Tagen mit Eintrag)',
      targets:
        'Eigenes Ziel {{kcal}} kcal · {{protein}} g Protein · Proteinziel an {{days}} Tagen erreicht',
      noTargets: 'Keine Zielwerte gesetzt',
      water:
        'Wasser an {{logged}} Tagen eingetragen · Ø {{avg}} ml · Ziel {{target}} ml · erreicht an {{days}} Tagen',
      supplements: 'Supplements',
      intakes: 'Fällig {{due}} · genommen {{taken}} · übersprungen {{skipped}} (ohne Namen)',
      noIntakes: 'Nichts fällig',
      journal: 'Befinden',
      journalDays_one: 'An {{count}} Tag Befinden eingetragen',
      journalDays_other: 'An {{count}} Tagen Befinden eingetragen',
      sleep: 'Schlaf Ø {{hours}} h · Schlafqualität Ø {{quality}} (1–5)',
      feeling: 'Energie Ø {{energy}} · Stimmung Ø {{mood}} · Muskelkater Ø {{soreness}} (1–5)',
      never:
        'Nicht dabei: Gedanken und Notizen, Fotos, Gewicht und Maße, Namen und Dosen von Supplements, Termine und andere Personen.',
      raw: 'Genau das wird gesendet',
    },
    send: 'Senden und besprechen',
    busy: 'Der Coach denkt nach …',
    wait: 'Das kann einige Minuten dauern. Lass die App dabei offen.',
    cancel: 'Nicht senden',
    close: 'Schließen',
    result: {
      heading: 'Was dem Coach auffällt',
      label: 'Vorschlag eines KI-Modells, kann danebenliegen.',
      questions: 'Zum Nachdenken',
      suggestion: 'Ein Vorschlag',
      removed_one:
        '{{count}} Satz der Antwort wurde ausgeblendet, weil er nach Diagnose, Dosis, Zielvorgabe oder Bewertung klang.',
      removed_other:
        '{{count}} Sätze der Antwort wurden ausgeblendet, weil sie nach Diagnose, Dosis, Zielvorgabe oder Bewertung klangen.',
      notStored: 'Die Antwort wird nicht gespeichert — schließen heißt weg.',
    },
    care: 'Wenn dich etwas belastet oder du dich länger nicht wohlfühlst, sprich mit einer Ärztin oder einem Arzt. Die App kann das nicht beurteilen.',
    note: {
      title: 'KI-Coach',
      save: 'Als Gedanke merken',
      saved: 'Als Gedanke gemerkt',
      failed: 'Merken hat nicht geklappt. Bitte erneut versuchen.',
    },
    error: {
      disabled: 'Der KI-Coach ist auf diesem Server nicht eingerichtet.',
      child: 'Den KI-Coach gibt es für Kinder nicht.',
      summary: 'Die Zusammenfassung passt nicht zum Server — bitte die App neu laden.',
      refused: 'Das Modell hat die Antwort abgelehnt.',
      invalid: 'Die Antwort des Modells war unbrauchbar. Bitte später erneut.',
      unsafe:
        'Die Antwort des Modells hat die Prüfung nicht bestanden (Diagnose, Dosis, Zielvorgabe oder Bewertung) und wird nicht gezeigt.',
      upstream: 'Das Modell ist gerade nicht erreichbar oder zu langsam. Bitte später erneut.',
      rate: 'Für heute sind genug Gespräche geführt. Morgen wieder.',
      offline: 'Keine Verbindung zum Server.',
      unknown: 'Das hat nicht geklappt. Bitte später erneut.',
    },
  },
  energy: {
    teenHeading: 'Meine Ziele',
    teenIntro:
      'Kalorien und Eiweiß legst du selbst fest. Kraftwerk rechnet für Jugendliche nichts aus Gewicht oder Größe — die Formeln dafür gelten für Erwachsene.',
    selfSet: 'Quelle: selbst gesetzt',
    heading: 'Körper und Bedarf',
    intro:
      'Daraus schätzt die App deinen Grundumsatz und Bedarf. Sport rechnet sie einzeln dazu, damit nichts doppelt zählt.',
    birthYear: 'Geburtsjahr',
    heightCm: 'Größe (cm)',
    sex: 'Formel',
    sexOption: { male: 'männlich', female: 'weiblich' },
    sexWhy: 'Die Formel für den Grundumsatz hat zwei Varianten — sonst nichts.',
    activity: 'Alltag ohne Sport',
    activityWhy: 'Training und Aktivitäten aus dem Kalender kommen einzeln dazu.',
    level: {
      sedentary: 'Überwiegend sitzend (Büro)',
      light: 'Sitzend, zeitweise gehend oder stehend',
      onFeet: 'Viel auf den Beinen (Verkauf, Handwerk)',
      heavy: 'Körperlich schwere Arbeit',
    },
    goal: 'Ziel',
    goalOption: { lose: 'Abnehmen', maintain: 'Halten', gain: 'Aufbauen' },
    rate: '% Körpergewicht je Woche',
    notSet: 'Keine Angabe',
    missing: 'Für die Schätzung fehlt noch: {{list}}.',
    lastWeight: 'Zuletzt gewogen: {{kg}} kg — heute leer lassen, wenn sich nichts geändert hat.',
    weightWhy: 'Gespeichert als Wiegetag von heute — der Verlauf steht im Tagebuch.',
    missingField: {
      birthYear: 'Geburtsjahr',
      sex: 'Formel',
      heightCm: 'Größe',
      weightKg: 'Gewicht',
      activityLevel: 'Alltag',
    },
    bmr: 'Grundumsatz ≈ {{kcal}} kcal',
    typical: 'Bedarf an einem typischen Tag mit deinem Training ≈ {{kcal}} kcal',
    noGoal: 'Wähle ein Ziel, dann schlägt die App Zielwerte vor.',
    suggestion:
      'Vorschlag: {{kcal}} kcal · {{protein}} g Protein · {{carbs}} g KH · {{fat}} g Fett',
    delta: {
      lose: '{{kcal}} kcal je Tag unter dem Bedarf',
      maintain: 'Etwa der Bedarf',
      gain: '{{kcal}} kcal je Tag über dem Bedarf',
    },
    take: 'Als Zielwerte übernehmen',
    taken: 'Übernommen.',
    isCurrent: 'Das sind schon deine Zielwerte.',
    estimate: 'Schätzung, keine Messung. Quellen:',
    currentTargets: 'Ziel: {{kcal}} kcal · {{protein}} g P · {{carbs}} g KH · {{fat}} g F',
    noTargets: 'Noch keine Zielwerte.',
    editTargets: 'Ändern',
    saveTargets: 'Zielwerte speichern',
    dayHeading: 'Bilanz',
    dayNeed: 'Bedarf ≈ {{kcal}} kcal',
    dayDone: 'davon Training {{kcal}} kcal',
    dayPlanned: 'davon erwartet {{kcal}} kcal (geplant)',
    dayEaten: 'gegessen {{kcal}} kcal',
    dayBalance: 'Bilanz {{sign}}{{kcal}} kcal',
    daySetup: 'Für eine Bilanz fehlen Angaben — Einstellungen → Körper und Bedarf.',
  },
  schedule: {
    heading: 'Nächste Trainings',
    setup: 'Trainingstage',
    done: 'Fertig',
    empty: 'Noch keine Trainingstage. Lege fest, an welchen Wochentagen du gehst.',
    noneSoon: 'In den nächsten zwei Wochen steht kein Training an.',
    more_one: '1 weiterer Termin',
    more_other: '{{count}} weitere Termine',
    fewer: 'Weniger zeigen',
    noPlanDay: 'ohne Plan-Tag',
    extra: 'zusätzlich',
    trained: 'Trainiert',
    cancelled: 'Ausgelassen',
    missed: 'Verpasst',
    date: 'Tag',
    time: 'Uhrzeit',
    move: 'Verschieben',
    cancel: 'Auslassen',
    cancelNamed: 'Training {{day}} auslassen',
    moveNamed: 'Training {{day}} verschieben',
    restore: 'Doch nicht auslassen',
    remove: 'Entfernen',
    removeSlot: '{{day}} {{time}} entfernen',
    rotationWhy:
      'An welchen Tagen du gehst. Welcher Plan-Tag drankommt, wechselt der Reihe nach — fällt ein Termin aus, kommt sein Plan-Tag beim nächsten Mal.',
    weekday: 'Wochentag',
    duration: 'Dauer (min)',
    addSlot: 'Trainingstag hinzufügen',
    reminder: 'Erinnerung „Losgehen um …"',
    reminderOn: 'Erinnerung an',
    reminderOff: 'Erinnerung aus',
    travel: 'Weg (min)',
    lead: 'Vorlauf (min)',
    reminderWhy:
      'Die Mitteilung kommt Weg + Vorlauf vor Beginn. Antippen quittiert sie; an Tagen mit Training oder abgesagtem Termin bleibt sie still.',
    addExtra: 'Zusätzlicher Termin',
    add: 'Hinzufügen',
    today: 'Training heute',
    todayLine: '{{time}} · {{name}}',
    leaveAt: 'Losgehen um {{time}}',
    toTraining: 'Zum Training',
    quick: {
      today: 'Heute {{time}}',
      tomorrow: 'Morgen {{time}}',
      day: '{{day}} {{time}}',
      other: 'Anderer Tag',
    },
    missedHeading: 'Training verpasst',
    missedLine: '{{day}} · {{time}}',
    missedWaiting: '{{name}} wartet aufs nächste Training — nichts fällt aus.',
    missedWaitingNoPlan: 'Nachholen oder auslassen — der Plan läuft dort weiter, wo du warst.',
    catchUp: 'Nachholen',
    catchUpNamed: 'Training {{day}} nachholen',
    reminderEnable: 'Erinnerung vor dem Training einschalten',
  },
  activity: {
    strength: 'Krafttraining',
    walking: 'Gehen',
    hiking: 'Wandern',
    running: 'Laufen',
    cycling: 'Radfahren',
    swimming: 'Schwimmen',
    yoga: 'Yoga',
    gardening: 'Gartenarbeit',
    football: 'Fußball',
    dancing: 'Tanzen',
  },
  calendar: {
    heading: 'Kalender',
    view: 'Ansicht',
    mode: { agenda: 'Liste', week: 'Woche', month: 'Monat' },
    previous: { week: 'Vorige Woche', month: 'Voriger Monat' },
    next: { week: 'Nächste Woche', month: 'Nächster Monat' },
    new: 'Neuer Termin',
    earlier: 'Frühere Termine zeigen',
    later: 'Weitere 30 Tage',
    empty: 'Keine Termine in diesem Zeitraum.',
    forWhom: 'für {{names}}',
    connectHint: 'Apple- oder Google-Kalender verbinden',
    free: 'Frei.',
    today: 'heute',
    allDay: 'ganzt.',
    allDayLong: 'Ganztägig',
    cancelled: 'Abgesagt',
    training: 'Training',
    imported: 'Eingelesen',
    addOn: 'Termin am {{date}} anlegen',
    entries_one: '1 Eintrag',
    entries_other: '{{count}} Einträge',
    fromSource: 'Aus „{{source}}" — ändern lässt er sich nur dort.',
    kind: {
      event: 'Privat',
      household: 'Haushalt',
      training: 'Aus deinem Trainingsplan',
      task: 'Aufgabe · {{list}}',
    },
    editor: {
      forWhom: 'Für wen',
      forWhomHint:
        'Niemand gewählt heißt: für alle. Sport zählt in deiner Bilanz nur, wenn du dabei bist.',
      new: 'Neuer Termin',
      edit: 'Termin bearbeiten',
      title: 'Titel',
      date: 'Tag',
      endDate: 'Bis einschließlich',
      time: 'Uhrzeit',
      duration: 'Dauer (min)',
      location: 'Ort',
      note: 'Notiz',
      activity: 'Aktivität',
      noActivity: 'Keine',
      activityMin: 'Minuten',
      activityWhy:
        'Mit Aktivität zählt der Termin in deiner Energiebilanz — als erwartet, bis er vorbei ist; abgesagt gar nicht.',
      shared: 'Im Haushalt teilen',
      save: 'Speichern',
      delete: 'Termin löschen',
      deleteWarning: 'Der Termin wird gelöscht — geteilte auch für die anderen im Haushalt.',
    },
    settings: {
      heading: 'Kalender verbinden',
      importHeading: 'Apple- oder Google-Kalender anzeigen',
      importIntro:
        'Über den geheimen Abo-Link deines Kalenders — ohne Passwort. Kraftwerk liest nur; ändern geht weiter in Apple/Google.',
      events_one: '1 Termin',
      events_other: '{{count}} Termine',
      fetched: 'geholt {{date}}',
      failed: 'Zuletzt nicht erreichbar: {{reason}}',
      remove: 'Entfernen',
      removeNamed: '{{name}} entfernen',
      name: 'Name',
      defaultName: 'Kalender',
      url: 'Abo-Link (webcal:// oder https://)',
      howTo: 'Wo finde ich den Link?',
      howToApple:
        'Apple (iCloud): Kalender-App auf dem Mac oder icloud.com → Kalender teilen → „Öffentlicher Kalender" → Link kopieren.',
      howToGoogle:
        'Google: calendar.google.com → Einstellungen des Kalenders → „Privatadresse im iCal-Format" kopieren.',
      add: 'Hinzufügen',
      adding: 'Hole den Kalender …',
      addFeed: 'Kalender hinzufügen',
      addFailed: 'Nicht hinzugefügt: {{reason}}',
      exportHeading: 'Kraftwerk in Apple/Google anzeigen',
      exportIntro:
        'Eine Abo-Adresse mit deinen Terminen und Trainings. Apple/Google zeigen sie nur an (Apple aktualisiert etwa stündlich, Google bis zu einem Tag).',
      onlyOnce: 'Die Adresse steht nur jetzt hier. Wer sie hat, sieht deine Termine.',
      openApple: 'In Apple Kalender abonnieren',
      copy: 'Adresse kopieren',
      googleHint:
        'Google: calendar.google.com → „Weitere Kalender" → „Per URL" → Adresse einfügen.',
      active: 'Eine Abo-Adresse ist eingerichtet.',
      password: 'Passwort zur Bestätigung',
      passwordWrong: 'Passwort stimmt nicht — oder der Server ist nicht erreichbar.',
      create: 'Abo-Adresse erzeugen',
      renew: 'Neue Adresse (die alte wird ungültig)',
      revoke: 'Abo beenden',
    },
  },
  letter: {
    open: 'Elternbrief lesen',
    heading: 'Elternbrief lesen',
    privacy:
      'Foto und Text bleiben auf diesem Gerät: Gelesen wird hier im Browser, nichts wird hochgeladen, das Foto wird nicht gespeichert. Nur was du übernimmst, geht wie jeder Termin in den Abgleich.',
    firstLoad:
      'Beim ersten Mal lädt die App die Texterkennung (rund 3 MB) von deinem Kraftwerk-Server — danach geht es auch offline.',
    camera: 'Foto aufnehmen',
    pick: 'Bild auswählen',
    typeIt: 'Text selbst eingeben',
    textLabel: 'Text des Briefs',
    textHint: 'Abtippen oder einfügen — die Regeln sind dieselben wie beim Foto.',
    analyze: 'Auswerten',
    reanalyze: 'Neu auswerten',
    back: 'Zurück',
    loading: 'Texterkennung wird geladen …',
    reading: 'Der Brief wird gelesen …',
    progress: '{{percent}} %',
    cancel: 'Abbrechen',
    error: {
      ocr: 'Die Texterkennung hat nicht geklappt. Versuch ein schärferes Foto bei gutem Licht — oder gib den Text selbst ein.',
      offline:
        'Die Texterkennung ließ sich nicht laden — offline? Sie kommt einmal vom eigenen Server. Du kannst den Text auch selbst eingeben.',
      save: 'Das Eintragen hat nicht geklappt. Nichts ist verloren — versuch es noch einmal.',
    },
    recognized: 'Erkannter Text',
    recognizedHint: 'Stimmt etwas nicht, korrigier es hier und werte neu aus.',
    nothing: 'Im Text steht nichts, was wie ein Termin, eine Frist oder ein Betrag aussieht.',
    nothingWay: 'Text prüfen',
    newEvent: 'Termin selbst anlegen',
    emptyText: 'Auf dem Foto war kein Text zu erkennen.',
    forWhom: 'Für wen ist der Brief?',
    forAll: 'Für alle',
    suggestions: 'Vorschläge',
    suggestionsHint: 'Unsichere sind nicht vorgewählt. Jeder lässt sich ändern.',
    take: 'Übernehmen',
    kindLabel: 'Art',
    kind: {
      event: 'Termin',
      task: 'Aufgabe',
    },
    title: 'Titel',
    date: 'Datum',
    dueDate: 'Fällig am',
    time: 'Uhrzeit',
    endDate: 'bis',
    noDate: 'Kein Datum erkannt — bitte eintragen.',
    noTitle: 'Titel fehlt.',
    list: 'Liste',
    newList: 'Neue Liste „{{name}}“',
    newListName: 'Schule',
    for: 'Für',
    source: 'Aus dem Brief: „{{line}}“',
    confidence: {
      high: 'sicher erkannt',
      medium: 'bitte prüfen',
      low: 'unsicher',
    },
    doubt: {
      ocrFixed: 'Ziffern aus der Texterkennung korrigiert',
      monthGuessed: 'Nur der Tag stand da, der Monat ist ergänzt',
      weekdayMismatch: 'Wochentag und Datum passen nicht zusammen',
      weekdayOnly: 'Nur ein Wochentag — gerechnet ab heute',
      relativeDay: '„Nächste Woche“ — gerechnet ab heute, nicht ab dem Briefdatum',
      noDate: 'Kein Datum gefunden',
      dateFromContext: 'Datum aus einem anderen Satz übernommen',
      titleGuessed: 'Kein Stichwort gefunden — Titel prüfen',
      amountUnclear: 'Betrag nicht sicher lesbar',
    },
    titles: {
      untitled: 'Aus dem Elternbrief',
      money: '{{amount}} mitgeben',
      moneyFor: '{{amount}} mitgeben – {{subject}}',
      transfer: '{{amount}} überweisen',
      transferFor: '{{amount}} überweisen – {{subject}}',
      moneyUnclear: 'Geld mitgeben (Betrag prüfen)',
      bring: 'Mitgeben: {{items}}',
      deadline: 'Frist: {{subject}}',
      deadlineGeneric: 'Frist aus dem Elternbrief',
    },
    skipped: 'Nicht vorgeschlagen',
    skip: {
      past: 'Schon vorbei',
      letterDate: 'Briefdatum',
    },
    apply_one: '{{count}} Vorschlag übernehmen',
    apply_other: '{{count}} Vorschläge übernehmen',
    applying: 'Wird eingetragen …',
    incomplete: 'Bei einem gewählten Vorschlag fehlt Titel oder Datum.',
    saved: 'Eingetragen — Termine: {{events}}, Aufgaben: {{tasks}}.',
    savedHint: 'Sie stehen jetzt im Kalender bzw. in der Liste — das Foto ist nicht gespeichert.',
    done: 'Fertig',
    another: 'Noch einen Brief lesen',
  },
  plan: {
    label: 'Planen',
    calendar: 'Kalender',
    tasks: 'Aufgaben',
    scope: {
      label: 'Was zeigen',
      mine: 'Meins',
      ours: 'Unseres',
      all: 'Alles',
      hintMine: 'Eigene Termine, Training, private Listen — und Geteiltes, das dich betrifft.',
      hintOurs: 'Was ihr im Haushalt teilt: Haushaltstermine und geteilte Listen.',
      hintAll: 'Alles aus allen Räumen in einer Planung.',
    },
  },
  tasks: {
    reward: 'Taschengeld fürs Erledigen (€)',
    rewardWhy:
      'Bekommt ein Kind, bei dem ihr „Geld für erledigte Aufgaben“ eingeschaltet habt, wenn es die Aufgabe abhakt. Leer = kein Geld.',
    rewardInvalid: 'Bitte einen Betrag bis {{max}} eingeben, etwa 0,50.',
    rewardShort: '{{amount}} fürs Erledigen',
    stars: 'Sterne fürs Erledigen',
    starsNone: 'Keine',
    starsShort_one: '{{count}} Stern',
    starsShort_other: '{{count}} Sterne',
    starsWhy:
      'Bekommt ein Kind, bei dem ihr „Sterne für erledigte Aufgaben“ eingeschaltet habt, wenn es die Aufgabe abhakt.',
    fairness: 'Diese Woche im Haushalt erledigt',
    someone: 'Jemand',
    heading: 'Aufgaben',
    due: 'Fällig',
    nothingDue: 'Nichts fällig in den nächsten sieben Tagen.',
    lists: 'Listen',
    newList: 'Neue Liste',
    noLists: 'Noch keine Listen.',
    noListsInScope: 'In dieser Auswahl gibt es keine Liste — „Alles“ zeigt alle.',
    kindLabel: 'Art der Liste',
    kind: { tasks: 'Aufgaben', checklist: 'Checkliste (Vorlage)' },
    kindWhy: {
      tasks: 'Aufgaben mit Tag, Uhrzeit, Wiederholung und Zuständigem.',
      checklist:
        'Eine Vorlage, die du je Durchgang frisch abhakst — etwa eine Packliste. Abgeschlossene Durchgänge stehen in der Vergangenheit.',
    },
    shared: 'im Haushalt',
    private: 'privat',
    shareWithHousehold: 'Im Haushalt teilen',
    makePrivate: 'Wieder privat machen',
    cannotUnshare: 'Privat machen geht nicht: Andere im Haushalt haben hier schon etwas angelegt.',
    listName: 'Name',
    create: 'Anlegen',
    rename: 'Umbenennen',
    listSettings: 'Liste',
    deleteList: 'Liste löschen',
    deleteWarning:
      'Die Liste und alle Aufgaben darin werden gelöscht — geteilte auch für die anderen.',
    emptyList: 'Noch nichts in dieser Liste.',
    addTask: 'Aufgabe hinzufügen',
    addItem: 'Punkt hinzufügen',
    addSub: 'Unterpunkt',
    editTask: 'Aufgabe bearbeiten',
    deleteTask: 'Aufgabe löschen',
    finishRun: 'Durchgang abschließen ({{done}}/{{total}})',
    runResult: '{{done}} von {{total}} erledigt',
    showHistory_one: 'Erledigt anzeigen (1)',
    showHistory_other: 'Erledigt anzeigen ({{count}})',
    hideHistory: 'Erledigtes ausblenden',
    noHistory: 'Noch nichts erledigt.',
    completeNamed: '{{title}} abhaken',
    reopenNamed: '{{title}} wieder öffnen',
    overdue: 'überfällig',
    overdueSince: 'überfällig seit {{date}}',
    today: 'heute',
    repeats: 'wiederkehrend',
    every: {
      day_one: 'täglich',
      day_other: 'alle {{count}} Tage',
      week_one: 'wöchentlich',
      week_other: 'alle {{count}} Wochen',
      month_one: 'monatlich',
      month_other: 'alle {{count}} Monate',
    },
    title: 'Was',
    dueDate: 'Tag',
    dueTime: 'Uhrzeit',
    timeWhy: 'Mit Uhrzeit kommt eine Mitteilung — an den, der zuständig ist.',
    repeat: 'Wiederholen',
    everyLabel: 'Alle',
    unitLabel: 'Einheit',
    unit: { day: 'Tage', week: 'Wochen', month: 'Monate' },
    assignee: 'Zuständig',
    nobody: 'Niemand bestimmtes',
    assigneeWhy: 'Erinnert und auf „Heute" angezeigt wird nur, wer zuständig ist.',
    note: 'Notiz',
    save: 'Speichern',
    todayHeading: 'Aufgaben heute',
    allTasks: 'Alle Aufgaben',
  },
  rings: {
    heading: 'Diese Woche',
    summary: '{{closed}} von {{total}} Ringen geschlossen',
    value: {
      training: '{{done}} von {{goal}} Trainings',
      protein: '{{done}} von {{goal}} Tagen Proteinziel',
      supplements: '{{done}} von {{goal}} Supplements genommen',
    },
    noGoal: {
      training: 'Keine Trainingstage geplant',
      protein: 'Kein Proteinziel gesetzt',
      supplements: 'Noch nichts fällig',
    },
    setup: {
      training: 'Trainingstage festlegen',
      protein: 'Proteinziel setzen',
      supplements: 'Supplements einrichten',
    },
    allClosed: 'Alle Ringe geschlossen — starke Woche.',
    newBest: 'Neuer Bestwert!',
    newBestValue: 'Geschätztes Maximum ≈ {{kg}} kg (+{{gain}} kg).',
    records_one: '1 Bestwert-Tag',
    records_other: '{{count}} Bestwert-Tage',
    settingsHeading: 'Erfolge',
    settingsIntro:
      'Bestwerte im Training, Wochenringe, Serien und Abzeichen — alles aus deinen Einträgen gerechnet, nichts erfunden.',
    settingsIntroTeen:
      'Trainings, Serien und Abzeichen — gefeiert wird, was du tust, nie dein Körper. Niemand im Haushalt sieht sie.',
    settingsOn: 'Erfolge anzeigen: an',
    settingsOff: 'Erfolge anzeigen: aus',
  },
  streaks: {
    heading: 'Serien',
    supplements: 'Supplements vollständig',
    journal: 'Tagebuch',
    trainingWeeks: 'Trainingswochen geschafft',
    days_one: 'Tag',
    days_other: 'Tage',
    weeks_one: 'Woche',
    weeks_other: 'Wochen',
    best: 'Rekord {{count}}',
    jokerUsed_one: '1 Joker eingesetzt',
    jokerUsed_other: '{{count}} Joker eingesetzt',
    jokerWhy_one:
      'Ein Joker je Monat rettet eine Tagesserie, wenn ein Tag ausfällt. Abgesagte Trainings brechen keine Wochenserie.',
    jokerWhy_other:
      '{{count}} Joker je Monat retten eine Tagesserie, wenn ein Tag ausfällt. Abgesagte Trainings brechen keine Wochenserie.',
  },
  badges: {
    heading_one: 'Abzeichen · 1 erreicht',
    heading_other: 'Abzeichen · {{count}} erreicht',
    none: 'Noch keins — das erste gibt es für die erste Einheit.',
    noneYet: 'Noch keins — wie weit es bis zum nächsten ist, steht darunter.',
    progress: '{{done}} von {{goal}}',
    sessions_one: 'Erste Einheit',
    sessions_other: '{{level}} Einheiten',
    volume_one: '{{level}} kg in einer Einheit',
    volume_other: '{{level}} kg in einer Einheit',
    records_one: 'Erster Bestwert',
    records_other: '{{level}} Bestwert-Tage',
    supplementStreak_one: '{{level}} Tag Supplements am Stück',
    supplementStreak_other: '{{level}} Tage Supplements am Stück',
    trainingWeeks_one: '{{level}} Trainingswoche in Folge',
    trainingWeeks_other: '{{level}} Trainingswochen in Folge',
    recipes_one: '{{level}} Gericht gegessen',
    recipes_other: '{{level}} verschiedene Gerichte gegessen',
    journal_one: '{{level}} Tagebuchtag',
    journal_other: '{{level}} Tagebuchtage',
    foodDays_one: '{{level}} Tag Essen eingetragen',
    foodDays_other: '{{level}} Tage Essen eingetragen',
    waterDays_one: '{{level}} Tag Wasserziel erreicht',
    waterDays_other: '{{level}} Tage Wasserziel erreicht',
  },
  householdGoal: {
    heading: 'Zusammen diese Woche',
    alone: 'Bisher teilt im Haushalt niemand sonst seine Trainingszahlen.',
    together: 'Zusammen {{done}} von {{planned}} Trainings',
    noPlan: 'Zusammen {{done}} Trainings',
    member: '{{done}} von {{planned}}',
    me: 'Du',
    settingsIntro:
      'Trainings dieser Woche (nur geplant und geschafft, nie Inhalte) mit dem Haushalt teilen — für ein gemeinsames Wochenziel. Sehen kann nur, wer selbst teilt.',
    settingsOn: 'Mit dem Haushalt teilen: an',
    settingsOff: 'Mit dem Haushalt teilen: aus',
  },
  e2e: {
    heading: 'Verschlüsselung',
    intro:
      'Ende-zu-Ende: Tagebuch, Fotos und Kosten werden auf dem Gerät verschlüsselt, bevor sie es verlassen. Der Server speichert nur noch Unlesbares.',
    introHint:
      'Entsperrt wird mit Face ID (deinem Passkey). Dazu bekommst du einmal einen Wiederherstellungscode — ohne Passkey und ohne Code kann niemand die Gedanken wiederherstellen, auch wir nicht.',
    setup: 'Verschlüsselung einrichten',
    working: 'Einen Moment …',
    codeIntro: 'Dein Wiederherstellungscode — er wird nur dieses eine Mal gezeigt:',
    codeLabel: 'Wiederherstellungscode',
    copy: 'Code kopieren',
    copied: 'Kopiert',
    codeWarning:
      'Lege ihn jetzt in deinen Passwort-Manager. Du brauchst ihn, wenn du ein Gerät ohne deinen Passkey entsperren willst.',
    codeSaved: 'Ich habe den Code sicher abgelegt.',
    finish: 'Fertig — jetzt verschlüsseln',
    ready:
      'Eingerichtet. Tagebuch, Fotos, Kosten, Einkauf, Listen, Bucketliste und Notizen über Kinder gehen nur noch verschlüsselt an den Server.',
    readyHint: 'Auf einem anderen Gerät entsperrst du mit Face ID oder dem Wiederherstellungscode.',
    householdWaiting:
      'Geteiltes im Haushalt (Kosten, Einkauf, Listen …) wird verschlüsselt, sobald alle Erwachsenen dort die Verschlüsselung eingerichtet haben. Bis dahin bleibt es für alle lesbar.',
    addPasskey: 'Face ID auf diesem Gerät hinzufügen',
    addPasskeyHint:
      'Dieses Gerät ist mit dem Code entsperrt. Mit Face ID geht es beim nächsten Mal ohne Code.',
    passkeyAdded: 'Face ID ist für dieses Gerät eingerichtet.',
    locked:
      'Dein Konto ist verschlüsselt, dieses Gerät noch nicht entsperrt. Bis dahin bleiben neue Gedanken auf dem Gerät.',
    unlockFaceId: 'Mit Face ID entsperren',
    codeInput: 'Oder Wiederherstellungscode',
    unlockCode: 'Mit Code entsperren',
    photoLocked: 'Verschlüsselt — entsperre das Gerät in den Einstellungen.',
    sealedHeading_one: '1 Eintrag ist verschlüsselt',
    sealedHeading_other: '{{count}} Einträge sind verschlüsselt',
    waitingParent:
      'Sie öffnen sich, sobald ein Elterngerät die App einmal geöffnet hat. Bis dahin bleiben deine Änderungen daran auf diesem Gerät.',
    waitingHousehold:
      'Geteilte Einträge des Haushalts. Sie öffnen sich, sobald ein anderes Gerät im Haushalt die App einmal geöffnet hat.',
    error: {
      cancelled: 'Abgebrochen.',
      noPrf:
        'Dieser Passkey kann keinen Schlüssel liefern. Mit einem Passkey aus dem iCloud-Schlüsselbund geht es.',
      otherAccount: 'Das war der Passkey eines anderen Kontos.',
      notVerified: 'Face ID wurde nicht bestätigt.',
      unknownPasskey:
        'Dieser Passkey ist für die Verschlüsselung noch nicht eingerichtet — entsperre mit dem Code und füge danach Face ID hinzu.',
      wrongCode: 'Der Code passt nicht.',
      exists:
        'Auf einem anderen Gerät wurde gerade schon eingerichtet. Entsperre dieses Gerät mit Face ID oder dem Code.',
      offline: 'Keine Verbindung zum Server — bitte später noch einmal.',
    },
  },
  // „Was der Server sieht“ (27.10.2026) — gerendert aus `SERVER_READABLE`.
  serverView: {
    heading: 'Was der Server sieht',
    tileIntro:
      'Kraftwerk verschlüsselt Ende-zu-Ende — mit Ausnahmen. Hier steht jede einzelne, und warum.',
    open: 'Alles ansehen',
    back: 'Zurück',
    intro:
      'Verschlüsselt wird auf deinem Gerät, bevor etwas es verlässt. Was der Server für Mitteilungen, Buchungen und die Regeln für Kinder braucht, bleibt für ihn lesbar. Diese Seite nennt alles davon.',
    status: {
      heading: 'Dein Konto',
      off: 'Für dein Konto ist die Verschlüsselung nicht eingerichtet. Bis dahin kann der Server alles lesen — auch das, was unten als verschlüsselt steht.',
      offChild:
        'Dein Konto ist noch nicht verschlüsselt. Das geschieht von selbst, sobald ein Elterngerät die App einmal geöffnet hat. Bis dahin kann der Server alles lesen.',
      locked:
        'Dein Konto ist verschlüsselt, dieses Gerät aber noch nicht entsperrt. Was es neu schreibt, wartet hier, bis es entsperrt ist — Klartext geht nicht hinaus.',
      ready: 'Dein Konto ist verschlüsselt und dieses Gerät entsperrt.',
      household:
        'Geteiltes im Haushalt wird erst verschlüsselt, wenn alle Erwachsenen dort die Verschlüsselung eingerichtet haben. Bis dahin kann der Server es lesen.',
      setup: 'Zur Verschlüsselung',
    },
    sealed: {
      heading: 'Verschlüsselt',
      intro:
        'Das öffnet nur dein Gerät — Geteiltes auch die Geräte im Haushalt. Der Server bewahrt es auf, lesen kann er es nicht.',
      photos: 'Tagebuch- und Rezeptbilder',
      tables: {
        journal_notes: 'Gedanken: Text, Titel, Stimmung, Schlagwörter und der verknüpfte Termin',
        journal_entries: 'Tagebuchtag: Schlaf, Energie, Stimmung, Muskelkater, Notiz und Maße',
        journal_photos: 'Bildunterschriften',
        recipe_cook_notes: 'Kochnotizen und Bewertungen',
        expense_categories: 'Kostenkategorien: Name und Budget',
        recurring_expenses: 'Wiederkehrende Kosten: Titel und Betrag',
        expenses: 'Ausgaben: Betrag, Kategorie und Notiz',
        savings_goals: 'Sparziele für Kosten: Name und Zielbetrag',
        savings_deposits: 'Einzahlungen auf Sparziele: Betrag',
        task_lists: 'Namen der Aufgabenlisten',
        events: 'Eigene Termine: die eingetragene Aktivität',
        household_events: 'Geteilte Termine: die eingetragene Aktivität',
        shopping_items: 'Einkaufsliste: Name, Menge, Einheit, Regal und Notiz',
        bucket_items: 'Bucketliste: Titel und Notiz',
        member_notes: 'Notizen über Kinder',
        exercises: 'Übungen: Name, Muskeln, Gerät, Sätze, Pause, Videos, Merker und Notizen',
        plan_exercises: 'Übungen im Plan: Reihenfolge, Sätze, Wiederholungen, Pause und Notiz',
        shops: 'Läden: Name und Regalfolge',
        event_marks: 'Markierungen an abonnierten Terminen: Aktivität, Dauer und „fällt aus“',
        profiles:
          'Körperwerte im Profil: Größe, Geburtsjahr, Formel, Alltag, Ziel, Kohlenhydrat- und Fettziel',
        places: 'Orte des Haushalts: Name, Mittelpunkt und Umkreis',
        location_checkins:
          'Standort-Check-ins: Ort, Genauigkeit, Ortsname, Art und die Mitteilung an den Haushalt',
        record_entries:
          'Akte: welche Art von Eintrag, alle Angaben darin und der Verweis in die Planung',
        household_meals:
          'Essensplan des Haushalts und Wünsche: Gericht mit Zutaten und Nährwerten, Notiz und wer kocht',
        household_meal_eaters:
          'Wer mitisst: Portion, was dazu gekauft wird, eigene Variante und der Hinweis „vegetarisch“',
        meal_deviations:
          'Deine Abweichungen vom Haushaltsplan: nicht mit, Portion, Extras, Variante und Dauerregeln',
        food_log:
          'Ernährungsprotokoll: was du gegessen hast, Gericht oder Lebensmittel, Menge, Uhrzeit, Kalorien, Kohlenhydrate, Fett, weitere Nährstoffe, Notiz und „geschätzt“',
      },
    },
    readable: {
      heading: 'Lesbar — und warum',
      intro:
        'Das liest der Server, weil er damit etwas tut, während die App zu ist. Was er nicht braucht, ist verschlüsselt.',
      also: 'Auch für: {{reasons}}',
      reasons: {
        reminders: {
          title: 'Mitteilungen und Erinnerungen',
          why: 'Sie kommen, während die App zu ist. Der Server muss wissen, wann — und was darin steht.',
        },
        review: {
          title: 'Wochenrückblick',
          why: 'Der Server rechnet ihn sonntags aus und schickt ihn als Mitteilung.',
        },
        shortcuts: {
          title: 'Kurzbefehle',
          why: 'Siri und Apple Health tragen ohne die App ein — der Server prüft und schreibt es.',
        },
        bookings: {
          title: 'Buchungen durch den Server',
          why: 'Taschengeld, Geld und Sterne für erledigte Aufgaben bucht der Server selbst — so wird nichts doppelt oder gar nicht gebucht.',
        },
        childRules: {
          title: 'Regeln für Kinder',
          why: 'Was ein Kind sehen und ändern darf, prüft der Server. Eine Grenze nur in der App wäre keine.',
        },
        household: {
          title: 'Haushalt',
          why: 'Wer dazugehört, entscheidet, wer Geteiltes sieht. Deine Trainingszahl der Woche sehen andere nur, wenn du sie teilst.',
        },
        calendarExport: {
          title: 'Kalender-Abo',
          why: 'Apple- und Google-Kalender holen deine Termine direkt beim Server ab, ohne die App.',
        },
        calendarImport: {
          title: 'Eingelesene Kalender',
          why: 'Abonnierte Kalender holt der Server beim Anbieter ab.',
        },
        sharing: {
          title: 'Gerichte weitergeben',
          why: 'Gibst du jemandem im Haushalt ein Gericht, kopiert der Server es samt Lebensmitteln.',
        },
        templates: {
          title: 'Neue Vorlagen',
          why: 'Neue Übungen und Pläne aus der App legt der Server in dein Konto. An der Kennung der Vorlage erkennt er, was schon da ist.',
        },
        notYet: {
          title: 'Noch nicht verschlüsselt',
          why: 'Der Server braucht das nicht — es ist nur noch nicht umgestellt.',
        },
      },
      tables: {
        profiles:
          'Einstellungen: Zeitzone, Sprache, Uhrzeiten, Module, Kalorien- und Eiweißziel und dein Gewicht',
        supplements: 'Supplements mit Dosis und Uhrzeit',
        supplement_intakes: '„Genommen“-Einträge',
        reminders: 'Erinnerungen, die der Server selbst anlegt',
        exercises: 'Übungen: nur welche Vorlage sie sind',
        training_plans: 'Trainingspläne',
        plan_days: 'Plan-Tage und ihre Namen',
        workout_sessions: 'Trainingseinheiten: Beginn und Ende',
        workout_sets: 'Sätze: Gewicht, Wiederholungen, Zeit, Strecke und Notiz',
        foods: 'Lebensmittel mit Nährwerten',
        recipes: 'Gerichte mit Zutaten und Schritten',
        recipe_ingredients: 'Zutaten der Gerichte',
        meal_plan_entries: 'Essensplan',
        food_log:
          'Ernährungsprotokoll: nur Tag, Mahlzeit und Eiweiß — was du gegessen hast, ist verschlüsselt',
        meal_skips: 'Ausgelassene Mahlzeiten',
        water_log: 'Getrunkenes Wasser',
        prep_checks: 'Abgehakte Vorbereitungen',
        training_slots: 'Trainingstage: Wochentag und Uhrzeit',
        training_days: 'Verschobene und abgesagte Trainingstermine',
        events: 'Eigene Termine: Titel, Zeit, Ort und Notiz',
        household_events: 'Geteilte Termine: Titel, Zeit, Ort und Notiz',
        feed_events: 'Termine aus abonnierten Kalendern',
        journal_entries: 'Tagebuchtag: Gewicht und Schritte',
        households: 'Haushalte und ihr Name',
        household_members:
          'Mitglieder: Anzeigename, Rolle, Geburtsjahr, dazu Stufe, Taschengeld- und Sterne-Regeln der Kinder',
        pantry_items: 'Vorrat',
        tasks: 'Aufgaben: Titel, Notiz, Fälligkeit, Zuständige und Belohnung',
        task_completions: 'Erledigte Aufgaben',
        pocket_goals: 'Sparziele der Kinder',
        pocket_money: 'Taschengeld-Buchungen',
        star_entries: 'Sterne',
        places: 'Orte: nur Haushalt und wer sie angelegt hat',
        location_checkins:
          'Standort-Check-ins: nur wer, in welchem Haushalt und wann — der Ort selbst ist verschlüsselt',
        record_entries:
          'Akte: nur wer sie führt, über wen, in welchem Haushalt, wer sie sehen darf und wann — der Inhalt ist verschlüsselt',
        household_meals:
          'Essensplan des Haushalts: nur Tag, Mahlzeit, Plan oder Wunsch und wer ihn angelegt hat — das Gericht ist verschlüsselt',
        household_meal_eaters:
          'Wer mitisst: nur welcher Eintrag und welche Person — die Portion ist verschlüsselt',
        meal_deviations:
          'Deine Abweichungen: nur auf welchen Eintrag sie zeigen — der Inhalt ist verschlüsselt',
      },
    },
    always: {
      heading: 'Was der Server immer sieht',
      intro:
        'Auch um Verschlüsseltes liegt ein lesbarer Umschlag — sonst könnte der Server weder abgleichen noch abgrenzen.',
      envelope:
        'Zu jedem Eintrag: Kennung, Konto, Haushalt, wann er angelegt, geändert oder gelöscht wurde, sein Datum (bei Gedanken auch die Uhrzeit), Verweise auf andere Einträge, Erledigt-Vermerke — und bei Kosten, wer bezahlt hat und in welchem Rhythmus.',
      photos: 'Zu jedem Bild: Dateigröße, Maße und wann es hochgeladen wurde.',
      storage: 'Wie viel Speicher dein Konto belegt.',
      photoEstimate:
        'Ein Foto, das du ausdrücklich zum Kalorienschätzen sendest: Der Server hält es nur im Speicher, bis es geschätzt ist (im Hintergrund, meist wenige Minuten), und legt es nie ab — nach einem Neustart ist es weg. Je nach Einrichtung schätzt er selbst oder reicht es an Anthropic weiter — welches von beiden, sagt der Hinweis vor dem Senden. Den Auftrag sieht er mit Tag, Mahlzeit und Stand; das Ergebnis legt er bis zur Übernahme ab, höchstens 24 Stunden, verschlüsselt, sobald dein Konto verschlüsselt ist.',
      coach:
        'Die Zusammenfassung, die du ausdrücklich an den KI-Coach sendest (Zahlen, Trainingstage, Übungsnamen — nie Gedanken, Notizen oder Gewicht): Der Server sieht sie für die Dauer der Antwort und legt sie nicht ab. Je nach Einrichtung antwortet sein eigenes Modell oder Anthropic — welches, sagt der Hinweis vor dem Senden.',
      serverOnly: {
        account: 'Konto: E-Mail-Adresse, Name und Kontingent — das Passwort nur als Abdruck',
        sessions: 'Anmeldungen: IP-Adresse, Browser und wann zuletzt benutzt',
        passkeys: 'Passkeys: Name und öffentlicher Schlüssel',
        keys: 'Schlüssel der Verschlüsselung — nur verpackt, ohne Passkey oder Code nicht zu öffnen',
        tokens: 'Schlüssel für Kurzbefehle und Kalender-Abo — nur als Abdruck',
        push: 'Mitteilungs-Abos: Adresse beim Push-Dienst, Browser und ob die Zustellung klappt',
        restTimer: 'Pausenende im Training samt nächstem Satz',
        calendarFeeds: 'Adressen abonnierter Kalender — der Server holt sie ja ab',
        codes: 'Einladungs- und Anmeldecodes für Kinder — nur als Abdruck',
        estimateJobs:
          'Foto-Schätzungen: Tag, Mahlzeit, Stand und Grund, höchstens 24 Stunden — das Ergebnis verschlüsselt, das Foto nie',
      },
    },
    backups: {
      heading: 'Sicherungen',
      body: 'Die nächtliche Sicherung der Datenbank wird verschlüsselt abgelegt; der Schlüssel zum Öffnen liegt nicht auf dem Server. Bilder werden als Kopie gesichert — dort sind sie so verschlüsselt, wie sie hochgeladen wurden.',
    },
  },
  storage: {
    heading: 'Speicher',
    used: '{{used}} von {{quota}} belegt',
    split: 'Einträge {{data}} · Bilder {{files}}',
    why: 'Alles zusammen: Einträge, Tagebuchfotos und Rezeptbilder.',
    full: 'Speicher voll — neue Fotos bleiben auf diesem Gerät und gehen hoch, sobald wieder Platz ist. Einträge werden weiter gespeichert.',
    fullRecipe: 'Speicher voll — das Bild wurde nicht gespeichert.',
    waiting_one: '1 Foto wartet auf das Hochladen.',
    waiting_other: '{{count}} Fotos warten auf das Hochladen.',
  },
  children: {
    heading: 'Kinder',
    badge: 'Kind',
    intro:
      'Kinder brauchen keine E-Mail und kein Passwort. Du planst für sie, schreibst Notizen und meldest bei Bedarf ihr eigenes Gerät an.',
    age: '{{age}} Jahre',
    add: 'Kind hinzufügen',
    name: 'Name',
    birthYear: 'Geburtsjahr',
    addSubmit: 'Hinzufügen',
    offline: 'Das geht nur mit Verbindung zum Server.',
    gone: 'Dieses Kind ist nicht mehr im Haushalt.',
    device: 'Eigenes Gerät',
    deviceHint:
      'Auf {{name}}s Telefon Kraftwerk öffnen, „Für Kinder: mit Code anmelden“ tippen und den Code eingeben.',
    makeCode: 'Code erzeugen',
    newCode: 'Neuen Code erzeugen',
    codeExpires: 'Gilt bis {{time}} Uhr und nur einmal.',
    notes: 'Notizen',
    noNotes: 'Noch keine Notizen.',
    noteBody: 'Notiz über {{name}} …',
    whoSees: 'Wer sieht sie?',
    visibility: {
      me: 'Nur ich',
      adults: 'Erwachsene im Haushalt',
      child: 'Auch {{name}}',
    },
    saveNote: 'Notiz speichern',
    deleteNote: 'Löschen',
    remove: '{{name}} aus dem Haushalt nehmen',
    removeWarning:
      '{{name}} wird abgemeldet und sieht nichts mehr aus diesem Haushalt. Termine und Notizen bleiben bei dir.',
    removeConfirm: 'Herausnehmen',
    forWhomHint:
      'Termine und Aufgaben für ein Kind legst du in Planen an: bei Terminen unter „Für wen“, bei Aufgaben unter „Zuständig“.',
    forMe: 'Für dich',
    forMeEmpty: 'Gerade keine Nachricht für dich.',
    level: {
      heading: 'Was darf es selbst?',
      readOnly: 'Ansehen geht — eintragen schalten deine Eltern frei.',
      small: 'Klein',
      school: 'Schulkind',
      teen: 'Jugendlich',
      smallHint:
        '{{name}} sieht Termine und Aufgaben und hakt eigene Aufgaben ab. Anlegen und Einkaufsliste machst du.',
      schoolHint:
        '{{name}} legt eigene Termine und Aufgaben an und schreibt auf die Einkaufsliste.',
      teenHint:
        '{{name}} plant selbst, schreibt auf die Einkaufsliste und übernimmt Aufgaben im Haushalt.',
    },
    nutrition: {
      heading: 'Ernährung',
      toggle: 'Ernährung mit eigenen Zielen',
      onHint:
        '{{name}} trägt Essen ein und setzt eigene Ziele für Kalorien und Eiweiß. Gewicht, Größe und Supplements bleiben verborgen.',
      offHint:
        'Aus: {{name}} sieht keine Ernährung. Schaltest du sie an, trägt {{name}} Essen ein und setzt eigene Ziele — ohne Gewicht, Größe und Supplements.',
      onlyTeen:
        'Ernährung mit eigenen Zielen gibt es ab der Stufe „Jugendlich“. Einträge von {{name}} bleiben erhalten, sind aber verborgen.',
    },
    training: {
      heading: 'Training',
      toggle: 'Training mit Plänen und Sätzen',
      onHint:
        '{{name}} plant Training, trägt Sätze mit Hantelgewicht ein und sieht den eigenen Fortschritt, dazu Erfolge für Regelmäßigkeit. Körpergewicht und Energie bleiben verborgen.',
      offHint:
        'Aus: {{name}} sieht kein Training. Schaltest du es an, plant {{name}} Einheiten und Trainingstage mit Erinnerungen — ohne Körpergewicht und Energie.',
      onlyTeen:
        'Training gibt es ab der Stufe „Jugendlich“. Einheiten von {{name}} bleiben erhalten, sind aber verborgen.',
    },
    water: {
      heading: 'Wasserziel',
      save: 'Übernehmen',
      loading: 'Wird geladen …',
      default: 'Vorgabe: {{ml}} ml am Tag. {{name}} kann das Ziel auch selbst ändern.',
      current: 'Eingestellt: {{ml}} ml am Tag. {{name}} kann das Ziel auch selbst ändern.',
      saved: 'Gespeichert — {{name}} sieht das neue Ziel nach dem nächsten Abgleich.',
      invalid: 'Bitte eine ganze Zahl zwischen 250 und 10000 ml.',
      needsNutrition:
        'Wasser gehört zur Ernährung. Gib erst Ernährung frei, dann stellst du hier das Ziel von {{name}} ein.',
    },
  },
  family: {
    heading: 'Familienanzeige',
    open: 'Familienanzeige öffnen',
    intro:
      'Für ein Tablet in der Küche: Uhr, Termine des Haushalts, wer heute dran ist, die Einkaufsliste und die Sterne der Kinder — groß und ohne Reiterleiste. Gezeigt wird nur Geteiltes, das jeder sehen darf; Eigenes, Körperwerte, Kosten und Taschengeld nie.',
    exit: 'Beenden',
    rewardsToggle: 'Abhaken am Tablet zählt für Belohnungen',
    rewardsOn:
      'Ab Werk an: Wer an der Familienanzeige eine Aufgabe eines Kindes abhakt, hakt sie für das Kind ab — es bekommt die Sterne und, wenn eingeschaltet, das Geld. Gilt für dieses Gerät.',
    rewardsOff:
      'Aus: Am Tablet Abgehaktes ist erledigt, bringt aber weder Sterne noch Geld. Belohnt wird, was das Kind selbst abhakt. Gilt für dieses Gerät.',
    noRewardsHere: 'Hier abgehakt gibt es keine Sterne und kein Geld.',
    today: 'Heute',
    tomorrow: 'Morgen',
    noEventsToday: 'Heute keine Termine.',
    noEventsTomorrow: 'Morgen keine Termine.',
    allDay: 'Ganztags',
    cancelled: 'Abgesagt',
    forWhom: 'für {{names}}',
    tasks: 'Wer ist dran',
    noTasks: 'Heute ist nichts offen.',
    everyone: 'Für alle',
    overdue: 'Überfällig',
    dueToday: 'Heute',
    taskStars_one: '{{count}} Stern',
    taskStars_other: '{{count}} Sterne',
    completeNamed: '„{{title}}“ erledigt',
    completed: '„{{title}}“ erledigt.',
    undo: 'Rückgängig',
    shopping: 'Einkaufsliste',
    shoppingEmpty: 'Die Einkaufsliste ist leer.',
    shoppingOpen_one: '{{count}} Eintrag offen',
    shoppingOpen_other: '{{count}} Einträge offen',
    shoppingMore_one: 'und {{count}} weiterer',
    shoppingMore_other: 'und {{count}} weitere',
    stars: 'Sterne',
    starGoal: '{{name}}: Sterne bis {{goal}}',
    noStarGoal: 'Noch keine Belohnung festgelegt.',
    noHousehold: 'Noch kein Haushalt auf diesem Gerät — einmal mit Netz abgleichen.',
    noWakeLock:
      'Dieses Gerät lässt den Bildschirm nicht von selbst an — in den Einstellungen des Tablets die automatische Sperre ausschalten.',
  },
  record: {
    heading: 'Akte',
    ownHeading: 'Meine Akte',
    ownIntro:
      'Ärztinnen, Impfungen, Allergien, Versicherung, Ausweise — nur für dich, auch nicht für den Haushalt. Verschlüsselt auf deinem Gerät.',
    childIntro:
      'Was die Erwachsenen im Haushalt über {{name}} wissen sollten. Verschlüsselt; {{name}} sieht es nur, wenn ihr es freigebt.',
    sharedHeading: 'Meine Akte',
    sharedIntro: 'Was deine Eltern für dich freigegeben haben.',
    empty: 'Noch keine Einträge — überall: Keine Angabe.',
    emptyShared: 'Keine Angabe — deine Eltern haben nichts freigegeben.',
    add: 'Eintrag hinzufügen',
    pickKind: 'Was möchtest du eintragen?',
    formLabel: '{{kind}} eintragen',
    save: 'Speichern',
    cancel: 'Abbrechen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    deleteWarning: 'Diesen Eintrag löschen? Aufgaben oder Termine daraus bleiben stehen.',
    deleteConfirm: 'Ja, löschen',
    invalid: 'Bitte den Namen ausfüllen und Daten als Tag angeben.',
    noValue: 'Keine Angabe',
    whoSees: 'Wer sieht das?',
    visibility: {
      adults: 'Nur Erwachsene',
      child: 'Auch {{name}}',
    },
    medicationHint:
      'Nur, was ihr selbst eintragt — etwa wie es die Ärztin verordnet hat. Kraftwerk empfiehlt keine Dosierung.',
    sizeHint: 'Kleidung und Schuhe. Körpergröße und Gewicht gehören nicht hierher.',
    heldOwn_one:
      'Ein Eintrag wartet auf deinem Gerät: Die Akte geht nur verschlüsselt hinaus. Richte die Verschlüsselung ein.',
    heldOwn_other:
      '{{count}} Einträge warten auf deinem Gerät: Die Akte geht nur verschlüsselt hinaus. Richte die Verschlüsselung ein.',
    heldHousehold_one:
      'Ein Eintrag wartet auf diesem Gerät, bis der Haushalt verschlüsselt ist — dafür richten alle Erwachsenen unter Einstellungen → Privatsphäre die Verschlüsselung ein.',
    heldHousehold_other:
      '{{count}} Einträge warten auf diesem Gerät, bis der Haushalt verschlüsselt ist — dafür richten alle Erwachsenen unter Einstellungen → Privatsphäre die Verschlüsselung ein.',
    toEncryption: 'Zur Verschlüsselung',
    due: {
      overdue: 'fällig seit {{date}}',
      soon: 'fällig am {{date}}',
      later: 'fällig am {{date}}',
    },
    plan: 'In die Planung',
    planAs: 'Als',
    planKinds: {
      task: 'Aufgabe',
      event: 'Termin',
    },
    planTitle: '{{kind}}: Frist',
    planTitleFor: '{{kind}}: Frist für {{name}}',
    planTitleLabel: 'Titel',
    planServerHint:
      'Titel von Aufgaben und Terminen liest der Server für Mitteilungen und das Kalender-Abo — Gesundheitsangaben besser weglassen.',
    planDate: 'Am',
    planTime: 'Uhrzeit',
    planTaskHint: 'Zur Uhrzeit kommt eine Mitteilung, wie bei jeder Aufgabe.',
    planTaskNoTime: 'Ohne Uhrzeit steht sie nur in der Liste — eine Mitteilung kommt dann nicht.',
    planEventHint:
      'Steht im Kalender. Eine Mitteilung kommt dafür nicht — dafür die Aufgabe wählen.',
    planSubmit: 'Eintragen',
    planned: {
      task: 'Steht als Aufgabe in der Planung (Frist {{date}}).',
      event: 'Steht als Termin im Kalender (Frist {{date}}).',
      household_event: 'Steht als geteilter Termin im Kalender (Frist {{date}}).',
    },
    planOutdated: 'Die Frist hat sich geändert — der Eintrag in der Planung noch nicht.',
    taskList: 'Fristen',
    kinds: {
      doctor: 'Ärztin / Arzt',
      vaccination: 'Impfung',
      checkup: 'Vorsorge',
      allergy: 'Allergie / Unverträglichkeit',
      medication: 'Medikament',
      size: 'Kleidergröße',
      school: 'Schule / Kita',
      emergency: 'Notfallkontakt',
      insurance: 'Versicherungskarte',
      document: 'Ausweis / Dokument',
    },
    fields: {
      doctor: {
        name: 'Name',
        specialty: 'Fach',
        phone: 'Telefon',
        address: 'Adresse',
      },
      vaccination: {
        vaccine: 'Impfung',
        date: 'Geimpft am',
        nextDue: 'Nächste fällig',
        note: 'Notiz',
      },
      checkup: {
        name: 'Untersuchung (z. B. U7)',
        date: 'Am',
        nextDue: 'Nächste fällig',
        note: 'Notiz',
      },
      allergy: {
        substance: 'Wogegen',
        reaction: 'Reaktion',
        note: 'Notiz',
      },
      medication: {
        name: 'Name',
        note: 'Hinweis',
      },
      size: {
        item: 'Was (z. B. Schuhe)',
        size: 'Größe',
        note: 'Notiz',
      },
      school: {
        name: 'Schule / Kita',
        group: 'Klasse / Gruppe',
        teacher: 'Lehrkraft / Erzieher:in',
        phone: 'Telefon',
        address: 'Adresse',
      },
      emergency: {
        name: 'Name',
        relation: 'Beziehung',
        phone: 'Telefon',
      },
      insurance: {
        insurer: 'Kasse / Versicherung',
        number: 'Versichertennummer',
        phone: 'Telefon',
      },
      document: {
        name: 'Dokument (z. B. Personalausweis)',
        number: 'Nummer',
        expiresOn: 'Gültig bis',
      },
    },
  },
  location: {
    heading: 'Standort',
    intro:
      'Teilen geht nur, solange die App offen ist — eine Web-App bekommt im Hintergrund keinen Standort. Ort, Name und Genauigkeit sind Ende-zu-Ende verschlüsselt; der Server sieht nur, dass jemand geteilt hat.',
    held_one:
      '1 Änderung wartet auf den Haushaltsschlüssel. Sie geht erst hinaus, wenn alle Erwachsenen die Verschlüsselung eingerichtet haben — nie unverschlüsselt.',
    held_other:
      '{{count}} Änderungen warten auf den Haushaltsschlüssel. Sie gehen erst hinaus, wenn alle Erwachsenen die Verschlüsselung eingerichtet haben — nie unverschlüsselt.',
    childOff: 'Deinen Standort teilen können deine Eltern für dich einschalten.',
    arrived: 'Bin angekommen',
    here: 'Ich bin hier',
    live: 'Ort teilen, solange die App offen ist',
    locating: 'Ort wird bestimmt …',
    confirm: {
      arrived: 'Angekommen — so teilen?',
      here: 'Hier — so teilen?',
      live: 'Ort teilen, solange die App offen ist?',
    },
    placeChoice: 'Ort',
    noPlace: 'Ohne Ortsname',
    outside: 'Außerhalb aller Orte — {{place}} ist {{distance}} entfernt.',
    duration: 'Wie lange',
    minutes_one: '{{count}} Minute',
    minutes_other: '{{count}} Minuten',
    liveForeground:
      'Aktualisiert alle {{minutes}} Minuten, nur solange die App vorn ist. Im Hintergrund oder geschlossen endet das Teilen — es läuft dort nicht weiter.',
    liveOn: 'Du teilst deinen Ort bis {{time}}.',
    liveStop: 'Teilen beenden',
    send: 'Teilen',
    cancel: 'Abbrechen',
    savedHeld: 'Gespeichert. Es geht hinaus, sobald der Haushaltsschlüssel da ist.',
    sent: 'Geteilt. Die anderen Erwachsenen bekommen eine Mitteilung.',
    error: {
      unsupported: 'Dieses Gerät kann den Standort nicht bestimmen.',
      denied:
        'Der Zugriff auf den Standort ist nicht erlaubt. Erlauben in den Einstellungen des Telefons (Datenschutz → Ortungsdienste) und noch einmal tippen.',
      timeout:
        'Kein Standort innerhalb von 20 Sekunden. Draußen oder am Fenster noch einmal versuchen.',
      unavailable: 'Der Standort ist gerade nicht zu bestimmen. Gleich noch einmal versuchen.',
    },
    accuracy: 'Genau auf etwa {{distance}}',
    accuracyCoarse: 'Ungenau: etwa {{distance}} — eher die Gegend als der Ort',
    accuracyUnknown: 'Genauigkeit: keine Angabe',
    whoIsWhere: 'Wer ist wo',
    mine: 'Dein Standort',
    none: 'Noch nichts geteilt.',
    me: 'Ich',
    someone: 'Jemand',
    kind: {
      arrived: 'angekommen',
      here: 'hier',
      live: 'teilt',
    },
    unnamed: 'unbenannter Ort',
    unnamedNear: 'unbenannter Ort, {{distance}} von {{place}}',
    when: '{{day}}, {{time}}',
    liveBadge: 'teilt gerade',
    openMaps: 'In Karten öffnen',
    withdraw: 'Zurücknehmen',
    history_one: 'Verlauf: 1 weiterer',
    history_other: 'Verlauf: {{count}} weitere',
    retention:
      'Aufbewahrt werden {{days}} Tage. Danach bleibt je Person nur der letzte Ort, alles Ältere wird gelöscht — auch beim Server.',
    places: 'Orte',
    noPlaces: 'Noch keine Orte. Liegt ein geteilter Ort in einem, wird er vorgeschlagen.',
    radius: 'Umkreis {{distance}}',
    delete: 'Löschen',
    deletePlace: '{{place}} löschen',
    addPlace: 'Ort hinzufügen',
    placeName: 'Name, z. B. Schule oder Oma',
    placeRadius: 'Umkreis',
    placeHint: 'Gespeichert wird der Ort, an dem du gerade bist.',
    savePlace: 'Hier als Ort speichern',
    childToggle: 'Standort teilen',
    childOnHint:
      '{{name}} kann teilen, wo sie/er ist. Sehen können es nur {{name}} selbst und die Erwachsenen.',
    childOffHint: 'Aus: {{name}} teilt keinen Standort.',
  },
  stars: {
    heading: 'Sterne',
    count_one: '{{count}} Stern',
    count_other: '{{count}} Sterne',
    toggle: 'Sterne für erledigte Aufgaben',
    off: 'Ab Werk aus. Gut für Kinder, die mit Geld noch nichts anfangen können: Eingeschaltet bekommt {{name}} die Sterne, die ihr an einer Aufgabe wählt, sobald sie abgehakt ist — einmal je Aufgabe und Tag, nie rückwirkend.',
    on: 'Eingeschaltet seit {{date}}: die Sterne wählt ihr an der Aufgabe (Planen → Aufgaben).',
    noGoal: 'Noch keine Belohnung festgelegt.',
    setGoal: 'Belohnung festlegen',
    changeGoal: 'Belohnung ändern',
    goalHeading: 'Belohnung',
    goalName: 'Was es gibt',
    goalNamePlaceholder: 'Eis',
    goalStars: 'Sterne',
    goalHint: 'Zum Beispiel „Eis“ für 10 Sterne. Beide Felder leer = keine Belohnung.',
    goalInvalid: 'Bitte beides angeben: was es gibt und wie viele Sterne (1 bis {{max}}).',
    saveGoal: 'Belohnung speichern',
    missing_one: 'Noch {{count}} Stern bis {{name}}',
    missing_other: 'Noch {{count}} Sterne bis {{name}}',
    reached: 'Geschafft — genug Sterne für {{name}}!',
    redeemGoal_one: '{{name}} einlösen ({{count}} Stern)',
    redeemGoal_other: '{{name}} einlösen ({{count}} Sterne)',
    bonus: 'Extra-Sterne geben',
    redeem: 'Sterne einlösen',
    amount: 'Sterne',
    note: 'Anlass',
    amountInvalid: 'Bitte eine ganze Zahl von 1 bis {{max}}.',
    book: 'Buchen',
    removeNamed: '„{{what}}“ zurücknehmen',
    kind: {
      task: 'Aufgabe erledigt',
      bonus: 'Extra',
      redeem: 'Eingelöst',
    },
  },
  pocket: {
    heading: 'Taschengeld',
    balance: 'Taschengeld jetzt',
    noRule: 'Noch kein regelmäßiges Taschengeld.',
    ruleWeekly: '{{amount}} jeden {{day}}',
    ruleMonthly: '{{amount}} jeden Monat am {{day}}.',
    weekday: {
      '1': 'Montag',
      '2': 'Dienstag',
      '3': 'Mittwoch',
      '4': 'Donnerstag',
      '5': 'Freitag',
      '6': 'Samstag',
      '7': 'Sonntag',
    },
    kind: {
      allowance: 'Taschengeld',
      gift: 'Dazubekommen',
      expense: 'Ausgegeben',
      save: 'Zurückgelegt',
      withdraw: 'Zurückgeholt',
      reward: 'Für eine Aufgabe',
    },
    rewards: {
      toggle: 'Geld für erledigte Aufgaben',
      off: 'Ab Werk aus. Eingeschaltet bucht Kraftwerk den Betrag, den ihr an einer Aufgabe eintragt, sobald {{name}} sie abhakt — einmal je Aufgabe und Tag, nie rückwirkend.',
      on: 'Eingeschaltet seit {{date}}: den Betrag tragt ihr an der Aufgabe ein (Planen → Aufgaben). Wieder geöffnet heißt: die Buchung fällt weg.',
    },
    goals: {
      heading: 'Sparziele',
      empty: 'Noch kein Sparziel — etwa für ein Fahrrad.',
      add: 'Sparziel anlegen',
      create: 'Anlegen',
      name: 'Wofür',
      target: 'Ziel (€)',
      split: 'Frei: {{free}} · gespart: {{saved}}',
      progress: '{{saved}} von {{target}}',
      missing: 'noch {{amount}}',
      reached: 'geschafft',
      gone: 'Sparziel gelöscht',
      removeNamed: 'Sparziel „{{name}}“ löschen',
      action: { save: 'Zurücklegen', withdraw: 'Zurückholen', gift: 'Dazugeben' },
      tooMuchSave: 'Frei sind nur {{amount}}.',
      tooMuchWithdraw: 'Gespart sind nur {{amount}}.',
    },
    empty: 'Noch nichts eingetragen.',
    removeNamed: '„{{what}}“ entfernen',
    bought: 'Ich habe gekauft',
    addHeading: 'Eintragen',
    amount: 'Betrag (€)',
    note: 'Wofür',
    save: 'Eintragen',
    setRule: 'Regelmäßiges Taschengeld einrichten',
    changeRule: 'Taschengeld ändern',
    ruleHeading: 'Regelmäßiges Taschengeld',
    interval: { weekly: 'Wöchentlich', monthly: 'Monatlich' },
    day: 'An welchem Tag',
    monthDay: 'am {{day}}.',
    ruleHint: 'Gebucht wird ab heute, nie rückwirkend — von selbst, an jedem Fälligkeitstag.',
    saveRule: 'Speichern',
    endRule: 'Beenden',
    cancel: 'Abbrechen',
  },
  costs: {
    heading: 'Kosten',
    previousMonth: 'Vorheriger Monat',
    nextMonth: 'Nächster Monat',
    vsPrevious: 'Vormonat: {{amount}}',
    noPrevious: 'Im Vormonat ist nichts eingetragen.',
    add: 'Ausgabe eintragen',
    edit: 'Ausgabe ändern',
    amount: 'Betrag (€)',
    date: 'Datum',
    note: 'Wofür (optional)',
    invalidAmount: 'Bitte einen Betrag wie 12,50 eingeben.',
    categoryLabel: 'Kategorie',
    paidBy: 'Bezahlt von',
    privateToggle: 'Nur für mich',
    private: 'privat',
    addSubmit: 'Eintragen',
    save: 'Speichern',
    delete: 'Löschen',
    skip: 'Überspringen',
    byCategory: 'Nach Kategorie',
    byPerson: 'Wer hat was ausgegeben',
    someone: 'Jemand',
    unknownPayer: 'Ohne Angabe',
    list: 'Ausgaben',
    empty: 'In diesem Monat ist noch nichts eingetragen.',
    budgetWarn: 'Über 80 % des Budgets.',
    budgetOver: 'Budget überschritten.',
    setBudget: 'Budget setzen für …',
    budgetFor: 'Monatsbudget für {{category}}',
    budgetPlaceholder: 'leer = kein Budget',
    recurring: 'Wiederkehrend',
    recurringEmpty: 'Noch nichts — etwa Miete, Verein, Fitnessstudio.',
    recurringTitle: 'Was',
    day: 'Am Tag',
    addRecurring: 'Wiederkehrende Ausgabe hinzufügen',
    deleteRecurring: '„{{title}}“ entfernen',
    interval: {
      monthly: 'monatlich am {{day}}.',
      yearly: 'jährlich am {{day}}.',
    },
    intervalName: { monthly: 'Monatlich', yearly: 'Jährlich' },
    goals: 'Sparziele',
    goalsEmpty: 'Noch kein Sparziel.',
    goalName: 'Wofür',
    goalTarget: 'Ziel (€)',
    addGoal: 'Sparziel anlegen',
    goalProgress: '{{percent}} % erreicht',
    depositOpen: 'Einzahlen',
    deposit: 'Einzahlen',
    depositAmount: 'Betrag für {{name}}',
    shoppingQuestion: 'Was hat der Einkauf gekostet?',
    shoppingHint: 'Wird als Lebensmittel eingetragen, bezahlt von dir — ändern geht unter Kosten.',
    category: {
      food: 'Lebensmittel',
      home: 'Haushalt',
      kids: 'Kinder',
      sport: 'Sport',
      leisure: 'Freizeit',
      mobility: 'Mobilität',
      health: 'Gesundheit',
      other: 'Sonstiges',
    },
  },
  nutrients: {
    name: {
      fiber: 'Ballaststoffe',
      sugar: 'Zucker',
      salt: 'Salz',
      vitaminD: 'Vitamin D',
      vitaminB12: 'Vitamin B12',
      folate: 'Folat',
      vitaminC: 'Vitamin C',
      iron: 'Eisen',
      calcium: 'Calcium',
      magnesium: 'Magnesium',
      zinc: 'Zink',
      iodine: 'Jod',
    },
    withUnit: '{{name}} ({{unit}})',
    per100g: 'je 100 g',
    perPortion: 'je Portion',
    microsHeading: 'Vitamine und Mineralstoffe ({{basis}}, falls auf der Packung)',
    dayHeading: 'Ballaststoffe, Zucker, Salz',
    range: { day: 'Dieser Tag', week: '7 Tage' },
    rangeLabel: 'Zeitraum',
    noEntriesDay: 'An diesem Tag ist nichts eingetragen.',
    microsWeekHeading: 'Vitamine und Mineralstoffe',
    noEntries: 'In den letzten sieben Tagen ist nichts eingetragen.',
    averageOver_one: 'Schnitt des einen Tages mit Einträgen in den letzten sieben.',
    averageOver_other: 'Schnitt über {{count}} Tage mit Einträgen in den letzten sieben.',
    nrvNote:
      'Vergleich mit den EU-Referenzwerten von der Packung (NRV) — eine Bezugsgröße, kein persönlicher Bedarf.',
    unknown: 'unbekannt',
    symbolLabel: '{{name}}: {{amount}} von {{reference}}',
    detail: '{{amount}} {{unit}} von {{reference}} {{unit}}.',
    detailAverage: 'Im Schnitt {{amount}} {{unit}} am Tag, Vergleich {{reference}} {{unit}}.',
    detailUnknown:
      'Zu {{name}} hat kein Eintrag eine Angabe — eintragen lässt es sich am Lebensmittel.',
    kind: {
      min: 'Richtwert (mindestens) der',
      max: 'Referenzmenge (Obergrenze) der',
      nrv: 'Nährstoffbezugswert der',
    },
    source: {
      dge: 'Deutschen Gesellschaft für Ernährung.',
      lmivReference: 'EU-Lebensmittelinformationsverordnung (wie auf Packungen).',
      lmivNrv: 'EU-Lebensmittelinformationsverordnung (wie auf Packungen).',
    },
    coverage:
      'Nur {{known}} von {{entries}} Einträgen haben eine Angabe — die Summe ist mindestens so hoch.',
    sugarNote:
      'Die Packung zählt allen Zucker, auch den aus Obst und Milch. Für zugesetzten Zucker empfehlen WHO und DGE weniger als 10 % der Energie.',
  },
  shops: {
    all: 'Alle',
    filter: 'Nach Laden filtern',
    manage: 'Läden',
    intro:
      'Eine Liste für alle Läden: Ein Artikel kann einen Laden haben, sonst steht er überall. Die App merkt sich, wo du etwas zuletzt gekauft hast.',
    name: 'Name des Ladens',
    add: 'Laden hinzufügen',
    remove: '{{name}} entfernen',
    shelves: 'Regale',
    shelvesIntro: 'So, wie du durch diesen Laden läufst — die Liste sortiert sich danach.',
    shelfUp: '{{name}} nach vorn',
    shelfDown: '{{name}} nach hinten',
    shop: 'Laden',
    anywhere: 'egal wo',
    trips: 'Einkaufstage',
    planTrip: 'Einkauf planen',
    noTrips:
      'Keiner geplant. Mit einem Einkaufstag rechnet „Aus dem Wochenplan“ bis zum nächsten Einkauf.',
    removeTrip: 'Einkauf {{day}} entfernen',
    timeOptional: 'Uhrzeit (optional)',
    save: 'Speichern',
    tripTitle: 'Einkauf',
    tripTitleShop: 'Einkauf · {{shop}}',
    untilNextTrip: 'Bis zum nächsten Einkauf am {{day}}.',
    todayHeading: 'Einkauf heute',
    todayOpen_one: '1 Sache offen',
    todayOpen_other: '{{count}} Sachen offen',
    toList: 'Zur Liste',
  },
  bucket: {
    heading: 'Bucketliste',
    intro:
      'Was du erleben willst — keine Aufgaben. Ohne Teilen sieht einen Eintrag nur du. „Planen“ trägt ihn in den Kalender ein, danach fragt die App, ob du es erlebt hast.',
    title: 'Was willst du erleben?',
    add: 'Merken',
    shareNew: 'Mit dem Haushalt teilen',
    ideas: 'Ideen',
    noIdeas: 'Noch keine. Was wolltest du schon immer mal machen?',
    planned: 'Geplant',
    plannedFor: 'Geplant für {{day}}',
    doneHeading: 'Erlebt',
    done: 'Erlebt',
    backToIdea: 'Zurück zu den Ideen',
    openDay: 'Tag öffnen',
    shared: 'mit dem Haushalt',
    private: 'nur für dich',
    plan: 'Planen',
    planNamed: '{{name}} planen',
    remove: '{{name}} entfernen',
    share: 'Mit dem Haushalt teilen',
    makePrivate: 'Nur für mich',
    toCalendar: 'In den Kalender',
    askHeading: 'Erlebt?',
    doneAndWrite: 'Ja — Foto oder Gedanke dazu',
    notYet: 'Noch nicht',
    story: 'Erlebt: {{title}}',
  },
  diary: {
    storyHeading: 'Was war',
    training: 'Training: {{title}}',
    minutes_one: '1 Minute',
    minutes_other: '{{count}} Minuten',
    sets_one: '1 Satz',
    sets_other: '{{count}} Sätze',
    food: 'Gegessen: {{kcal}} kcal, {{protein}} g Protein',
    proteinReached: 'Proteinziel erreicht',
    water: 'Getrunken: {{liters}} l',
    tasksDone_one: 'Erledigt: {{list}}',
    tasksDone_other: '{{count}} erledigt: {{list}}',
    previousMonth: 'Vorheriger Monat',
    nextMonth: 'Nächster Monat',
    moodValue: 'Stimmung {{value}} von 5',
    energyValue: 'Energie {{value}} von 5',
    noMood: 'keine Stimmung eingetragen',
    trained: 'trainiert',
    written: 'Fotos oder Gedanken',
    legend:
      'Fläche: Stimmung (sonst Energie), kräftiger ist besser. Punkt: Training. Kringel: Fotos oder Gedanken.',
  },
  water: {
    heading: 'Wasser',
    onTrack: 'Im Plan für diese Uhrzeit.',
    dueBy: 'Bis jetzt wären etwa {{ml}} ml mehr dran.',
    plus: '+ {{ml}} ml',
    glassNamed: 'Ein Glas eintragen ({{ml}} ml)',
    bottleNamed: 'Eine Flasche eintragen ({{ml}} ml)',
    other: 'Andere',
    undoNamed: 'Zuletzt eingetragene {{ml}} ml zurücknehmen',
    amount: 'Menge (ml)',
    add: 'Eintragen',
    changeTarget: 'Tagesziel ändern',
    settingsHeading: 'Wasser',
    target: 'Tagesziel (ml)',
    targetSource:
      'Vorgabe 1500 ml: Die Deutsche Gesellschaft für Ernährung empfiehlt Erwachsenen rund 1,5 Liter Getränke am Tag — bei Sport und Hitze mehr.',
    midday: 'Mittags fragen, wie viel ich getrunken habe',
    pace: 'Erinnern, wenn ich hinterher bin (11, 15, 18 Uhr)',
    remindersWhy:
      'Jede Mitteilung kommt einmal und mahnt nicht nach. Die Mittagsfrage bleibt still, wenn das Ziel schon erreicht ist; das Erinnern nur, wenn du mindestens ein Glas hinter dem über den Tag verteilten Ziel liegst.',
  },
  meals: {
    heading: 'Mahlzeiten anpassen',
    intro:
      'Uhrzeit und Erinnerung je Mahlzeit. Mit Uhrzeit sortiert der Tag nach der Uhrzeit — auch Training und Supplements stehen dann an ihrer Stelle. Ohne Uhrzeit bestimmst du die Reihenfolge mit den Pfeilen.',
    introChild:
      'Uhrzeit und Erinnerung je Mahlzeit. Mit Uhrzeit sortiert der Tag nach der Uhrzeit — auch das Training steht dann an seiner Stelle. Ohne Uhrzeit bestimmst du die Reihenfolge mit den Pfeilen.',
    up: '{{name}} nach oben',
    down: '{{name}} nach unten',
    remove: '{{name}} entfernen',
    time: 'Uhrzeit',
    timeNamed: 'Uhrzeit {{name}}',
    noTime: 'Ohne Uhrzeit keine Erinnerung — Reihenfolge mit den Pfeilen.',
    byTime: 'Steht nach der Uhrzeit im Tag.',
    workoutNote:
      'Liegen immer direkt vor und nach dem Training und fehlen an Tagen ohne Training. Für eine feste Zeit einen Snack hinzufügen.',
    reminderOn: 'Erinnerung an',
    reminderOff: 'Erinnerung aus',
    reminderNamed: 'Erinnerung für {{name}}',
    addSnack_one: 'Snack hinzufügen (noch 1)',
    addSnack_other: 'Snack hinzufügen (noch {{count}})',
    snacksFull: 'Drei weitere Snacks sind das Höchste.',
    atWithReminder: '{{time}} · mit Erinnerung',
    skip: 'Auslassen',
    skipNamed: '{{name}} an diesem Tag auslassen',
    skipped: 'An diesem Tag ausgelassen',
    unskip: 'Doch nicht',
    unskipNamed: '{{name}} doch nicht auslassen',
    training: 'Training',
    trainingNoPlan: 'ohne Plan-Tag',
    trainingDuration: '{{minutes}} min',
    trainingDone: 'erledigt',
  },
  modules: {
    heading: 'Was ich nutze',
    intro: 'Abgeschaltetes verschwindet aus der Leiste und von „Heute“ und erinnert nicht mehr.',
    keep: 'Deine Daten bleiben erhalten — wieder einschalten bringt alles zurück.',
    on: 'An',
    off: 'Aus',
    confirm: 'So übernehmen',
    name: {
      training: 'Training',
      nutrition: 'Ernährung',
      planning: 'Planen',
      household: 'Haushalt',
      journal: 'Tagebuch',
    },
    why: {
      training: 'Pläne, Sätze, Fortschritt, Trainingstage mit Erinnerung.',
      nutrition: 'Mahlzeiten, Zielwerte, Wochenplan, Supplements mit Erinnerung.',
      planning: 'Kalender, Termine, Aufgaben — auch für Kinder.',
      household: 'Einkaufsliste, Vorrat, Kosten und Mitglieder, geteilt im Haushalt.',
      journal: 'Befinden am Morgen, Gedanken, Fotos, Rückblick.',
    },
  },
  setup: {
    progress: 'Einrichten · {{done}} von {{total}}',
    tileHeading: 'In ein paar Minuten startklar',
    tileIntro:
      'Damit Kraftwerk erinnern, rechnen und planen kann, braucht es ein paar Angaben. Jeder Schritt lässt sich überspringen.',
    continue: 'Weiter: {{step}}',
    hide: 'Ausblenden',
    hideHint: 'Lässt sich in den Einstellungen wieder öffnen.',
    doneLabel: '(erledigt)',
    openLabel: '(offen)',
    stepOf: 'Schritt {{step}} von {{total}}',
    optional: 'Optional',
    stepDone: 'Erledigt.',
    back: 'Zurück',
    next: 'Weiter',
    skip: 'Überspringen',
    finish: 'Fertig',
    reopen: 'Einrichtung öffnen',
    reopenIntro:
      'Die Schritte vom Anfang — Installieren, Mitteilungen, Ziele, Training — noch einmal durchgehen.',
    step: {
      modules: {
        short: 'Was du nutzt',
        title: 'Was nutzt du?',
        why: 'Wähle die Bereiche, die du brauchst. Der Rest bleibt aus dem Weg — und lässt sich jederzeit in den Einstellungen einschalten.',
      },
      install: {
        short: 'Auf den Home-Bildschirm',
        title: 'Auf den Home-Bildschirm',
        why: 'Auf dem iPhone kommen Erinnerungen nur an, wenn Kraftwerk wie eine App installiert ist.',
      },
      push: {
        short: 'Erinnerungen erlauben',
        title: 'Erinnerungen erlauben',
        why: 'Kraftwerk erinnert an Supplements, Training und Pausenende — und fasst nach, bis du es abhakst.',
      },
      body: {
        short: 'Körper und Ziel',
        title: 'Körper und Ziel',
        why: 'Aus Größe, Gewicht, Alter, Alltag und Ziel schlägt die App deine Zielwerte vor. Übernommen wird erst auf deinen Tipp.',
      },
      training: {
        short: 'Training planen',
        title: 'Training planen',
        why: 'Wähle einen Plan und lege fest, an welchen Tagen du trainierst. Daraus entstehen Erinnerungen und Wochenringe.',
      },
      more: {
        title: 'Mehr einrichten',
        why: 'Alles hier ist freiwillig und lässt sich jederzeit nachholen.',
      },
    },
    install: {
      already: 'Kraftwerk läuft schon vom Home-Bildschirm.',
      button: 'Installieren',
      ios1: 'Unten in Safari auf das Teilen-Symbol tippen (Quadrat mit Pfeil nach oben).',
      ios2: '„Zum Home-Bildschirm“ wählen und „Hinzufügen“ tippen.',
      ios3: 'Kraftwerk ab jetzt über das neue Symbol auf dem Home-Bildschirm öffnen.',
      relogin: 'Eventuell musst du dich dort noch einmal anmelden.',
    },
    training: {
      plan: 'Plan',
      noPlans: 'Noch kein Plan vorhanden.',
      own: 'Eigenen Plan anlegen',
    },
    more: {
      supplements: {
        title: 'Supplements',
        why: 'Was du nimmst, wann und zu welcher Mahlzeit — mit Erinnerung, bis es abgehakt ist.',
        action: 'Supplements einrichten',
      },
      household: {
        title: 'Haushalt',
        why: 'Einkaufsliste, Vorrat, Termine und Aufgaben mit den Menschen teilen, mit denen du lebst.',
        action: 'Haushalt einrichten',
      },
      calendar: {
        title: 'Kalender verbinden',
        why: 'Termine aus Apple oder Google in Kraftwerk sehen — und Kraftwerk im eigenen Kalender.',
        action: 'Kalender verbinden',
      },
    },
  },
  journalLock: {
    heading: 'Tagebuch-Sperre',
    intro:
      'Vor dem Tagebuch fragt die App nach der Gerätesperre (Face ID, Fingerabdruck oder PIN) — auf diesem Gerät. Das schützt vor neugierigen Blicken, nicht vor dem Auslesen des Geräts.',
    on: 'Sperre an',
    off: 'Sperre aus',
    unsupported: 'Dieser Browser kann keine Passkeys — die Sperre geht hier nicht.',
    needPasskey:
      'Dafür braucht dieses Gerät einen Passkey für dein Konto (weiter unten unter „Passkeys").',
    locked: 'Tagebuch gesperrt',
    lockedHint:
      'Entsperre mit der Gerätesperre. Nach fünf Minuten oder wenn die App im Hintergrund war, fragt sie erneut.',
    unlock: 'Entsperren',
    usePassword: 'Mit Passwort entsperren',
    password: 'Passwort',
    unlockPassword: 'Passwort prüfen',
    wrongPassword: 'Das Passwort stimmt nicht.',
    tooMany: 'Zu viele Versuche. Bitte später noch einmal.',
    offline: 'Das Passwort lässt sich nur mit Verbindung zum Server prüfen.',
    result: {
      cancelled: 'Abgebrochen — oder es gibt keinen Passkey auf diesem Gerät.',
      notVerified: 'Das Gerät hat nicht nach Face ID, Fingerabdruck oder PIN gefragt.',
      otherAccount: 'Dieser Passkey gehört zu einem anderen Konto.',
    },
  },
  notes: {
    heading: 'Gedanken',
    add: 'Gedanke festhalten',
    empty: 'Noch nichts festgehalten an diesem Tag.',
    edit: 'Bearbeiten',
    title: 'Überschrift (optional)',
    time: 'Uhrzeit',
    body: 'Was dir durch den Kopf geht',
    placeholder: 'Schreib einfach los — Diktieren geht über das Mikrofon der Tastatur.',
    tagsHint: 'Mit #wort setzt du Schlagwörter, etwa #urlaub oder #familie.',
    mood: 'Stimmung (optional)',
    moodValue: 'Stimmung {{value}}/5',
    event: 'Zu einem Termin',
    noEvent: 'Keiner',
    about: 'Zu: {{title}} · {{date}}',
    save: 'Speichern',
    delete: 'Gedanken löschen',
    deleteWarning: 'Der Gedanke und seine Fotos werden gelöscht.',
    count_one: '1 Gedanke',
    count_other: '{{count}} Gedanken',
    search: 'Gedanken durchsuchen',
    searchShort: 'Gedanken durchsuchen …',
    searchHint: 'Wörter oder #schlagwort',
    noResults: 'Nichts gefunden.',
    memories: 'An diesem Tag',
    monthAgo: 'Vor einem Monat',
    yearsAgo_one: 'Vor einem Jahr',
    yearsAgo_other: 'Vor {{count}} Jahren',
    writeAbout: 'Eintrag dazu schreiben',
    hasNote: '✎ Gedanke',
  },
  journal: {
    checkinHeading: 'Befinden',
    nothingEntered: 'Nichts eingetragen.',
    addLater: 'Nachtragen',
    edit: 'Bearbeiten',
    doneEditing: 'Fertig',
    scaleRather: 'eher {{word}}',
    scaleMiddle: 'mittel',
    scaleValue: '{{word}} ({{value}}/5)',
    notEnteredList: 'Nicht eingetragen: {{list}}',
    weight: 'Gewicht',
    weightHint: 'z. B. 82,5',
    weightInvalid: 'Das sieht nicht nach Kilogramm aus (20–400).',
    weightTrend: 'Gewicht',
    weightAvg: 'kg im Schnitt der letzten 7 Tage',
    weightChange: '{{change}} kg zur Vorwoche',
    weightTooFew: 'Für einen Trend braucht es mindestens {{min}} Wiegetage je Woche.',
    weightLatest: 'Zuletzt {{kg}} kg am {{date}}',
    steps: {
      value: '{{steps}} Schritte',
      source: 'aus Apple Health',
    },
    measurements: {
      toggle: 'Körpermaße eintragen',
      toggleCount: 'Körpermaße ({{count}} gemessen)',
      how: 'Morgens, nüchtern, mit Maßband auf der Haut — immer an derselben Stelle. Leer heißt nicht gemessen.',
      waist: 'Taille',
      hips: 'Hüfte',
      chest: 'Brust',
      upperArm: 'Oberarm',
      thigh: 'Oberschenkel',
      bodyFat: 'Körperfett',
      invalid: 'Bitte zwischen {{min}} und {{max}} {{unit}}.',
      value: { cm: '{{value}} cm', '%': '{{value}} %' },
      trend: 'Körpermaße',
      latest: '{{value}} am {{date}}',
      change: '{{change}} seit {{date}}',
      single: 'erster Wert',
      measured: 'Maße genommen',
    },
    more: 'Mehr eintragen — Stimmung, Notiz, Fotos',
    back: 'Zurück',
    today: 'Heute',
    days: {
      checkin: 'Befinden',
      note: 'Gedanke',
      photo: 'Foto',
      noCheckin: 'Noch kein Befinden eingetragen.',
      thisWeek: 'Diese Woche',
      lastWeek: 'Letzte Woche',
      weekRange: '{{from}} – {{to}}',
      emptyOne: '{{day}} ohne Eintrag',
      emptyRun: '{{from}} bis {{to}} · {{count}} Tage ohne Eintrag',
      older: 'Ältere Wochen',
      bucket: 'Erlebt: {{title}}',
      training: 'Training: {{list}}',
      kcal: '{{kcal}} kcal',
      water: '{{liters}} l Wasser',
      events_one: '1 Termin',
      events_other: '{{count}} Termine',
    },
    noPhotos: 'Noch keine Fotos.',
    openDay: 'Tag öffnen: {{day}}',
    tabs: {
      label: 'Tagebuch',
      days: 'Tage',
      month: 'Monat',
      bucket: 'Bucketliste',
      review: 'Rückblick',
      photos: 'Fotos',
      week: 'Woche',
    },
    summary: {
      weight: '{{kg}} kg',
      sleep: 'Schlaf {{hours}} h',
      energy: 'Energie {{value}}/5',
      mood: 'Stimmung {{value}}/5',
      soreness: 'Muskelkater {{value}}/5',
      photos_one: '1 Foto',
      photos_other: '{{count}} Fotos',
    },
    heading: "Wie geht's heute?",
    sleepHours: 'Schlaf letzte Nacht',
    sleepLess: 'Eine halbe Stunde weniger Schlaf',
    sleepMore: 'Eine halbe Stunde mehr Schlaf',
    notEntered: 'nicht eingetragen',
    hours: '{{hours}} h',
    sleepQuality: 'Schlafqualität',
    energy: 'Energie',
    mood: 'Stimmung',
    soreness: 'Muskelkater',
    note: 'Notiz',
    scale: {
      bad: 'schlecht',
      good: 'gut',
      low: 'leer',
      high: 'voll da',
      strong: 'stark',
      none: 'keiner',
    },
    photos: {
      saveToFiles: 'In Dateien sichern',
      saved: 'Gesichert',
      heading: 'Fotos',
      add: 'Foto hinzufügen',
      preparing: 'Wird verkleinert …',
      hint: 'Wird auf dem Gerät verkleinert (1600 px). Der Aufnahmeort wird dabei entfernt.',
      failed: 'Das Foto ließ sich nicht verarbeiten.',
      waiting: 'Wartet auf Upload',
      uploadFailed: 'Upload fehlgeschlagen ({{reason}}) — liegt weiter auf dem Gerät',
      elsewhere: 'Noch nicht hochgeladen — liegt auf einem anderen Gerät',
      alt: 'Tagebuchfoto',
      remove: 'Entfernen',
    },
    rating: {
      question:
        "Wie lief's? Schwach ist, was du so bewertest — die App leitet das nicht aus den Gewichten ab.",
      label: "Wie lief's?",
      low: 'schwach',
      high: 'stark',
      skip: 'Ohne Bewertung beenden',
      shown: 'Bewertet: {{rating}} von 5',
      none: 'Nicht bewertet',
      rate: 'Bewerten',
      change: 'Ändern',
    },
    context: {
      before: 'Davor:',
      meals: '24 h: {{kcal}} kcal, {{protein}} g Protein',
      noMeals: '24 h: nichts protokolliert',
      lastMealMinutes: 'letzte Mahlzeit {{minutes}} min vorher',
      lastMeal: 'letzte Mahlzeit {{hours}} h {{minutes}} min vorher',
      sleep: 'Schlaf {{hours}} h',
      noSleep: 'Schlaf nicht eingetragen',
      energy: 'Energie {{energy}}/5',
    },
  },
  settings: {
    jump: 'Bereiche der Einstellungen',
    groups: {
      reminders: 'Erinnerungen',
      me: 'Ich und Ziele',
      connections: 'Verbindungen',
      privacy: 'Privatsphäre',
      look: 'Darstellung',
      account: 'Zugang und Daten',
    },
    review: {
      heading: 'Wochenrückblick',
      intro:
        'Sonntags ab 18:00 eine Mitteilung mit den Zahlen der Woche: Protein, Training, Supplements, Gewicht. Antippen öffnet die Wochenansicht im Tagebuch.',
      on: 'Sonntags melden: an',
      off: 'Sonntags melden: aus',
    },
    heading: 'Einstellungen',
    close: 'Schließen',
    prep: 'Abend-Erinnerung',
    look: 'Darstellung',
    logoutPhotos_one:
      '1 Foto ist noch nicht hochgeladen und geht beim Abmelden verloren. Erst mit Netz abgleichen?',
    logoutPhotos_other:
      '{{count}} Fotos sind noch nicht hochgeladen und gehen beim Abmelden verloren. Erst mit Netz abgleichen?',
    logoutEstimates_one:
      '1 Foto zum Schätzen ist noch nicht beim Server und geht beim Abmelden verloren. Erst mit Netz abgleichen?',
    logoutEstimates_other:
      '{{count}} Fotos zum Schätzen sind noch nicht beim Server und gehen beim Abmelden verloren. Erst mit Netz abgleichen?',
    logoutPending_one:
      '1 Änderung ist noch nicht beim Server und geht beim Abmelden verloren. Erst mit Netz abgleichen?',
    logoutPending_other:
      '{{count}} Änderungen sind noch nicht beim Server und gehen beim Abmelden verloren. Erst mit Netz abgleichen?',
    logoutRetry: 'Erneut abgleichen',
    logoutChecking: 'Gleiche ab …',
    logoutAnyway: 'Trotzdem abmelden',
    export: {
      action: 'Meine Daten exportieren',
      busy: 'Stelle zusammen …',
      hint: 'Alles, was der Server über dein Konto weiß, als Datei. Fotos, die nur auf dem Gerät liegen, sicherst du über „In Dateien sichern".',
      done: 'Export erstellt.',
      failed: 'Export fehlgeschlagen — ohne Verbindung zum Server geht es nicht.',
    },
    delete: {
      action: 'Konto löschen',
      warning:
        'Löscht dein Konto mit allen Daten — Supplements, Trainings, Ernährung, Tagebuch, Fotos. Das lässt sich nicht rückgängig machen. Vorher exportieren?',
      shared:
        'Was du in einem geteilten Haushalt auf Einkaufsliste oder Vorrat gesetzt hast, bleibt für die anderen erhalten.',
      password: 'Passwort zur Bestätigung',
      confirm: 'Endgültig löschen',
      busy: 'Lösche …',
      wrongPassword: 'Das Passwort stimmt nicht. Es wurde nichts gelöscht.',
      failed: 'Löschen fehlgeschlagen — es wurde nichts gelöscht. Besteht eine Verbindung?',
    },
  },
  prep: {
    heading: 'Für morgen',
    nothing: 'Für morgen ist nichts vorzubereiten, und es fehlt nichts.',
    missing: 'Fehlt zuhause',
    missingGrams: 'fehlen {{grams}} g',
    missingCheck: 'prüfen — Menge offen',
    unknownIngredients: 'Ohne Zutatenliste, deshalb nicht geprüft: {{recipes}}.',
    done: 'Erledigt',
    doneAlready: 'Für heute Abend erledigt.',
    reminderOff:
      'Abend-Erinnerung ist aus. Eingeschaltet meldet sich das Telefon am Vorabend — nur, wenn etwas vorzubereiten ist oder fehlt.',
    reminderOn: 'Abend-Erinnerung um {{time}}. Ist nichts zu tun, bleibt das Telefon still.',
    time: 'Uhrzeit',
    enable: 'Einschalten',
    change: 'Ändern',
    disable: 'Ausschalten',
    tooLate: 'Spätestens {{time}} — danach liefe die Erinnerung ab, bevor sie gesendet wird.',
  },
  shopping: {
    fromPlan: 'Aus dem Wochenplan übernehmen',
    noHousehold: 'Noch kein Haushalt auf diesem Gerät — bitte einmal mit Netz synchronisieren.',
    amountUnknown: 'Menge offen',
    amountUnknownShort: 'offen',
    unit: { g: 'g', ml: 'ml', piece: 'Stück' },
    unitFormat: { g: '{{amount}} g', ml: '{{amount}} ml', piece: '{{amount}} Stück' },
    category: {
      produce: 'Obst & Gemüse',
      bakery: 'Brot & Backwaren',
      chilled: 'Kühlregal',
      frozen: 'Tiefkühl',
      dry: 'Trockenware',
      canned: 'Konserven & Gläser',
      spices: 'Gewürze & Öle',
      drinks: 'Getränke',
      household: 'Haushalt',
      other: 'Sonstiges',
    },
    tabs: {
      label: 'Einkauf',
      list: 'Liste',
      pantry: 'Vorrat',
      costs: 'Kosten',
      pocket: 'Taschengeld',
      members: 'Mitglieder',
    },
    item: {
      fromLibrary: 'Aus der Bibliothek',
      name: 'Was',
      amount: 'Menge',
      unit: 'Einheit',
      category: 'Regal',
      details: 'Menge und Regal',
    },
    list: {
      heading: 'Einkaufsliste',
      open: 'offen',
      add: 'Hinzufügen',
      empty: 'Nichts offen. Neues von Hand oder aus dem Wochenplan.',
      fromPlan: 'aus dem Plan',
      remove: '{{name}} entfernen',
      done_one: '1 abgehakt',
      done_other: '{{count}} abgehakt',
      finish_one: 'Einkauf abschließen · 1 in den Vorrat',
      finish_other: 'Einkauf abschließen · {{count}} in den Vorrat',
      finishHint:
        'Abgehaktes kommt in den Vorrat und verschwindet von der Liste. Gleiche Sache in gleicher Einheit wird addiert.',
      finished_one: '1 Eintrag in den Vorrat gebucht.',
      finished_other: '{{count}} Einträge in den Vorrat gebucht.',
    },
    consumption: {
      heading: 'Bald wieder dran',
      intro: 'Aus dem, was ihr bisher abgehakt habt — ab drei Käufen, gerechnet auf diesem Gerät.',
      every_one: 'etwa täglich gekauft',
      every_other: 'etwa alle {{count}} Tage gekauft',
      since_one: 'zuletzt gestern',
      since_other: 'zuletzt vor {{count}} Tagen',
      uncertain_one: 'noch unsicher, erst 1 Kauf',
      uncertain_other: 'noch unsicher, erst {{count}} Käufe',
      add: 'Auf die Liste',
      addNamed: '{{name}} auf die Liste',
      hide: 'Ausblenden',
      hideNamed: '{{name}} bis zum nächsten Kauf nicht vorschlagen',
      added: '{{name}} steht auf der Liste.',
    },
    plan: {
      heading: 'Aus dem Wochenplan',
      intro:
        'Was deine geplanten Gerichte brauchen, minus Vorrat und minus dem, was schon auf der Liste steht. Gerechnet wird in Gramm aus den Zutaten.',
      from: 'Von',
      to: 'Bis',
      empty: 'Im gewählten Zeitraum ist nichts geplant.',
      missingRefs_one:
        '1 Planeintrag zeigt auf ein gelöschtes Gericht oder Lebensmittel und fehlt in der Rechnung.',
      missingRefs_other:
        '{{count}} Planeinträge zeigen auf gelöschte Gerichte oder Lebensmittel und fehlen in der Rechnung.',
      needed: 'Bedarf {{grams}} g',
      neededUnknown: 'Bedarf: Menge im Plan unbekannt',
      inPantry: 'Vorrat {{grams}} g',
      inPantryUnknown: 'im Vorrat, Menge offen',
      toBuy: 'fehlen {{grams}} g',
      for: 'für {{recipes}}',
      add_one: '1 auf die Liste',
      add_other: '{{count}} auf die Liste',
      unstructuredHeading: 'Gerichte ohne Zutatenliste',
      unstructuredIntro:
        'Für diese Gerichte sind keine Zutaten in Gramm hinterlegt — die App kann nichts rechnen und rät auch nicht. Antippen setzt einen Bestandteil so auf die Liste, wie er dasteht.',
      times_one: '1× geplant',
      times_other: '{{count}}× geplant',
      noItems: 'Keine Zutaten eingetragen — bitte im Gericht ergänzen.',
      quickAdd: '{{text}} auf die Liste setzen',
    },
    status: {
      buy: 'kaufen',
      covered: 'im Vorrat',
      listed: 'steht drauf',
      check: 'prüfen',
    },
    pantry: {
      heading: 'Vorrat',
      intro:
        'Was zuhause liegt. Mit Menge in Gramm wird es vom Bedarf abgezogen; ohne Menge heißt es auf der Liste „prüfen". Beim Kochen wird nicht automatisch abgebucht.',
      add: 'In den Vorrat',
      empty: 'Noch nichts im Vorrat.',
      amountFor: 'Menge von {{name}}',
      remove: '{{name}} aus dem Vorrat entfernen',
    },
    household: {
      heading: 'Haushalt',
      intro:
        'Einkaufsliste, Vorrat und was du teilst (Termine, Aufgaben, Kosten) siehst du mit allen hier. Training, Ernährung und Tagebuch bleiben privat.',
      inviteHeading: 'Jemanden einladen',
      inviteIntro:
        'Erzeugt einen Code, sieben Tage gültig, einmal verwendbar. Schick ihn auf einem Weg deiner Wahl.',
      invite: 'Code erzeugen',
      inviteAgain: 'Neuen Code erzeugen',
      inviteExpires: 'Gültig bis {{date}}',
      joinHeading: 'Einem Haushalt beitreten',
      joinIntro:
        'Bist du hier der einzige Erwachsene, kommt alles Geteilte mit — auch deine Kinder. Sonst bleibt es bei den anderen.',
      code: 'Einladungscode',
      join: 'Beitreten',
      joined_one: 'Beigetreten. 1 Eintrag kam mit.',
      joined_other: 'Beigetreten. {{count}} Einträge kamen mit.',
      leaveHeading: 'Austreten',
      leaveIntro:
        'Alles Geteilte bleibt bei den anderen. Du bekommst einen neuen, leeren Haushalt.',
      leaveAlone:
        'Du bist allein in diesem Haushalt — austreten würde Liste und Vorrat verwaisen lassen.',
      leaveLastAdult:
        'Du bist hier der einzige Erwachsene — die Kinder blieben allein zurück. Lade erst jemanden ein oder tritt einem anderen Haushalt bei: Dann kommen sie mit.',
      leave: 'Austreten',
      leaveConfirm: 'Wirklich austreten',
      codeInvalid: 'Der Code ist ungültig, abgelaufen oder schon benutzt.',
      conflict: 'Das geht gerade nicht — du bist schon Mitglied oder allein im Haushalt.',
      tooMany: 'Zu viele Versuche. Bitte in ein paar Minuten erneut.',
      offline: 'Keine Verbindung zum Server. Haushalt ändern geht nur online.',
    },
  },
  householdMeals: {
    heading: 'Essen im Haushalt',
    intro:
      'Was der Haushalt isst. Alle essen ab Werk mit, je eine Portion — abweichen geht hier oder ausführlich im eigenen Tag unter Ernährung.',
    loading: 'Lädt …',
    noHousehold: 'Noch kein Haushalt auf diesem Gerät — er kommt mit dem ersten Abgleich.',
    weekOf: 'Woche ab {{date}}',
    prevWeek: 'Vorherige Woche',
    nextWeek: 'Nächste Woche',
    thisWeek: 'Diese Woche',
    dayEmpty: 'Nichts geplant.',
    add: 'Eintragen',
    addNamed: 'Gericht für {{day}} eintragen',
    perPortion: '{{kcal}} kcal · {{protein}} g Eiweiß je Portion',
    noValues: 'Nährwerte unbekannt — zählt in keine Bilanz',
    source: 'Quelle: {{source}}',
    cooks: 'Kocht: {{name}}',
    eaters: 'Wer isst mit · {{amount}} Portionen vom Gericht',
    me: 'Ich',
    unknownMember: 'Unbekannt',
    portions_one: '{{amount}} Portion',
    portions_other: '{{amount}} Portionen',
    notEating: 'isst nicht mit',
    variant: 'eigene Variante: {{name}}',
    extras_one: '{{count}} Extra',
    extras_other: '{{count}} Extras',
    vegetarian: 'vegetarisch',
    vegetarianSelf: 'Du isst vegetarisch — eine eigene Variante wählst du im Tag unter Ernährung.',
    eats: 'Isst mit',
    notEatingShort: 'Nicht mit',
    meEatsNamed: 'Ich esse bei {{name}} mit',
    eatsNamed: '{{name}} isst bei {{dish}} mit',
    portionFor: 'Portion für {{name}}',
    removeNamed: '{{name}} aus dem Plan löschen',
    toShopping: 'Zur Einkaufsliste',
    toShoppingHint:
      '„Aus dem Wochenplan übernehmen“ auf der Einkaufsliste rechnet mit allen Portionen der Mitesser, ihren Extras und Varianten — minus Vorrat.',
    form: {
      recipe: 'Eigenes Gericht',
      free: 'Nur ein Name',
      slot: 'Mahlzeit',
      pickRecipe: 'Gericht',
      choose: 'Bitte wählen',
      name: 'Name',
      note: 'Notiz',
      cook: 'Wer kocht',
      nobody: 'Noch offen',
      frozenHint:
        'Das Gericht wird eingefroren: Name, Zutaten und Nährwerte gelten so, wie sie jetzt sind. Spätere Änderungen am Rezept wandern nicht mit.',
      save: 'Eintragen',
      cancel: 'Abbrechen',
    },
    wishes: {
      heading: 'Wünsche',
      intro: 'Was sich jemand wünscht. Erwachsene übernehmen es in den Plan.',
      empty: 'Gerade keine Wünsche.',
      name: 'Was wünschst du dir?',
      note: 'Notiz',
      save: 'Wünschen',
      from: 'von {{name}}',
      take: 'In den Plan',
      takeNamed: '{{name}} in den Plan übernehmen',
      takeWith: 'Mit eigenem Gericht (Zutaten und Nährwerte)',
      takeNoRecipe: 'Nur der Name',
      day: 'Tag',
      decline: 'Ablehnen',
      declineNamed: 'Wunsch {{name}} ablehnen',
      removeOwn: 'Zurücknehmen',
      removeOwnNamed: 'Wunsch {{name}} zurücknehmen',
      smallChild: 'Wünsche tragen die Eltern für dich ein.',
    },
    day: {
      kicker: 'Aus dem Haushaltsplan',
      counted: '{{amount}}× · {{kcal}} kcal · {{protein}} g',
      noValues: 'zählt nicht — Nährwerte unbekannt',
      notEating: 'Du isst nicht mit',
      fromRule: 'Portion nach Dauerregel',
      instead: 'statt {{name}}',
      skip: 'Nicht mit',
      skipNamed: 'Bei {{name}} nicht mitessen',
      eatAgain: 'Doch mit',
      eatAgainNamed: 'Bei {{name}} doch mitessen',
      portion: 'Portion',
      portionNamed: 'Meine Portion von {{name}} ändern',
      portionLabel: 'Meine Portion (Faktor)',
      portionSave: 'Übernehmen',
      portionReset: 'Wie alle',
      extra: 'Extra dazu',
      extraNamed: 'Extra zu {{name}}',
      variant: 'Eigene Variante',
      variantNamed: 'Eigene Variante statt {{name}}',
      variantRemove: 'Variante zurücknehmen',
      extraGrams: '{{grams}} g',
      extraPortions_one: '{{portions}} Portion',
      extraPortions_other: '{{portions}} Portionen',
      extraValues: '{{kcal}} kcal · {{protein}} g Eiweiß',
      removeExtraNamed: 'Extra {{name}} entfernen',
      pickFood: 'Lebensmittel',
      pickRecipe: 'Gericht',
      choose: 'Bitte wählen',
      grams: 'Menge (g)',
      portions: 'Portionen',
      add: 'Hinzufügen',
      noRecipeValues:
        'Dieses Gericht hat keine Nährwerte — als Extra zählte es mit 0. Bitte erst Werte eintragen.',
      vegetarianHint: 'Du isst vegetarisch — hier hilft eine eigene Variante.',
      proteinGap:
        'Mit allem Eingetragenen und Geplanten fehlen dir heute noch {{grams}} g zu deinem eigenen Eiweißziel.',
    },
    rules: {
      heading: 'Mitessen im Haushalt',
      intro:
        'Gilt für jeden Eintrag des Haushaltsplans, bis du dort etwas anderes sagst. Der Haushalt sieht nur deine Portion, nicht deine Nährwerte.',
      factor: 'Portion beim {{meal}}',
      sameAsAll: 'Wie alle (1)',
      trainingExtra: 'An Trainingstagen nach dem Training dazu',
      trainingNone: 'Nichts',
      vegetarian: 'Statt Fleisch vegetarisch (Hinweis an den Haushalt)',
      save: 'Speichern',
      saved: 'Gespeichert.',
    },
  },
} as const;

/**
 * Weitet die Literaltypen aus `de` zu `string` auf.
 *
 * Ohne das verlangt `Translations` von jeder Übersetzung den *wortgleichen*
 * deutschen Text — die Schlüsselstruktur soll erzwungen werden, nicht der Inhalt.
 */
type WidenStrings<T> = {
  [K in keyof T]: T[K] extends string ? string : WidenStrings<T[K]>;
};

export type Translations = WidenStrings<typeof de>;
